// before 20-5-2026
// import React, { useEffect, useState } from 'react';
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Collapse,
//   MenuItem,
//   Divider,
//   Box,
//   IconButton,
// } from '@mui/material';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { useTheme } from '@emotion/react';
// import { styled } from '@mui/material/styles';
// import Switch from '@mui/material/Switch';
// import FormGroup from '@mui/material/FormGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import { ExpandLess, ExpandMore } from '@mui/icons-material';
// import DarkModeIcon from '@mui/icons-material/DarkMode';
// import LightModeIcon from '@mui/icons-material/LightMode';
// // استيراد الأيقونات
// import GridViewIcon from '@mui/icons-material/GridView';
// import Person3OutlinedIcon from '@mui/icons-material/Person3Outlined';
// import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import AssistantPhotoOutlinedIcon from '@mui/icons-material/AssistantPhotoOutlined';
// import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
// import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
// import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
// import HorizontalSplitOutlinedIcon from '@mui/icons-material/HorizontalSplitOutlined';
// import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
// import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
// import VideoSettingsOutlinedIcon from '@mui/icons-material/VideoSettingsOutlined';
// import SouthAmericaIcon from '@mui/icons-material/SouthAmerica';
// import LocationSearchingOutlinedIcon from '@mui/icons-material/LocationSearchingOutlined';
// import AddLocationOutlinedIcon from '@mui/icons-material/AddLocationOutlined';
// import BubbleChartOutlinedIcon from '@mui/icons-material/BubbleChartOutlined';
// import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
// import DoNotDisturbAltOutlinedIcon from '@mui/icons-material/DoNotDisturbAltOutlined';
// import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
// import WebhookIcon from '@mui/icons-material/Webhook';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';
// import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
// import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
// import ScreenRotationOutlinedIcon from '@mui/icons-material/ScreenRotationOutlined';
// import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
// import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
// import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
// import SwitchAccountOutlinedIcon from '@mui/icons-material/SwitchAccountOutlined';
// import StackedLineChartOutlinedIcon from '@mui/icons-material/StackedLineChartOutlined';
// import Diversity3Icon from '@mui/icons-material/Diversity3';
// import ShowChartIcon from '@mui/icons-material/ShowChart';
// import AccountBoxIcon from '@mui/icons-material/AccountBox';
// import AddTaskIcon from '@mui/icons-material/AddTask';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import LogoutIcon from '@mui/icons-material/Logout';
// import LoupeIcon from '@mui/icons-material/Loupe';
// import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
// import AssistantPhotoIcon from '@mui/icons-material/AssistantPhoto';
// import { useDispatch, useSelector } from 'react-redux';
// import { Logoutsession_one_Device } from '../Redux/Actions/Devices_Action';
// import AssessmentIcon from '@mui/icons-material/Assessment'; // للتقرير الرئيسي
// import TrendingUpIcon from '@mui/icons-material/TrendingUp'; // لتقرير المبيعات
// import ChecklistIcon from '@mui/icons-material/Checklist'; // لتقرير الصفقات المنجزة

// export const Leftsidebare2 = ({
//   setmode,
//   mode,
//   openDrawer,
//   isMobile,
//   toggleDrawer,
//   setOpenDrawer,
// }) => {
//   const dispatch = useDispatch();
//   const [open, setOpen] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [userlogin, setuserlogin] = useState('');

//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const isPrivilegedRole = [
//     'Sales',
//     'Team Leader',
//     'Manager',
//     'Admin',
//     'Marketer',
//     'Accountant',
//   ].includes(userlogin?.data?.role);

//   useEffect(() => {
//     const path = location.pathname;
//     const navbar = document.getElementById('navbarr');
//     const shouldHide = path === '/' || path === '/Login';

//     if (typeof setOpenDrawer === 'function') {
//       setOpenDrawer(!shouldHide);
//     }

//     if (navbar) {
//       navbar.style.display = shouldHide ? 'none' : 'flex';
//     }
//   }, [location.pathname, setOpenDrawer]);

//   const [openMenu, setOpenMenu] = useState({});
//   const handleToggle = (text) => {
//     setOpenMenu((prev) => ({ ...prev, [text]: !prev[text] }));
//   };

//   const [isLoggedOut, setIsLoggedOut] = useState(localStorage.getItem('isLoggedIn'));
//   const theme = useTheme();

//   const isAdminOrManager = (user) => user?.data?.role === 'Admin';
//   const isSales = (user) => user?.data?.role === 'Sales';
//   const isTeamLeader = (user) => user?.data?.role === 'Team Leader';
//   const isManager = (user) => user?.data?.role === 'Manager';
//   const isAccountant = (user) => user?.data?.role === 'Accountant';
//   const isMarketer = (user) => user?.data?.role === 'Marketer';

//   const isActive = (path) => location.pathname === path;
//   const isChildActive = (children) => children?.some((child) => location.pathname === child.path);

//   const savedDeviceId = localStorage.getItem('deviceId');
//   const [loadinglogout, setloadinglogout] = useState(true);

//   // logout
//   const logout = async () => {
//     // insert data for user activation when make login
//     //  await dispatch(Add_User_Activation_Logout_Action({
//     //   user_id:user?.data?._id,
//     //   deviceType:isMobile ? 'Mobile' : isTablet ? 'Tablet' : isDesktop ? 'Desktop' : 'Unknown',
//     //   Browser_name:browserName,
//     // EngineName:engineName,
//     // osName:osName,
//     // ip:location.ip,
//     // city:location.city,
//     // region:location.region,
//     // country:location.country,
//     // postalcode:location.postal,
//     // loc:location.loc,
//     // hosetname:location.hostname,
//     // type:"LogOut"
//     // }))
//     // console.log('📱 DeviceId from localStorage:', savedDeviceId);
//     // console.log('👤 User ID:', user?.data?._id);
//     setloadinglogout(true);
//     await dispatch(Logoutsession_one_Device(userlogin?.data?._id, savedDeviceId));
//     setloadinglogout(false);

//     // //delete use active data
//     // localStorage.removeItem('token');
//     // localStorage.removeItem('user');
//     // localStorage.setItem("isLoggedIn", "false");

//     // window.location.href=`#/`;
//   };

//   const reslogout = useSelector((state) => state.All_Users_Devices.User_Devices);

//   useEffect(() => {
//     if (loadinglogout === false) {
//       //  delete use active data
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       localStorage.setItem('isLoggedIn', 'false');

//       window.location.href = `#/`;
//     }
//   }, [loadinglogout]);

//   const MaterialUISwitch = styled(Switch)(({ theme }) => ({
//     width: 62,
//     height: 34,
//     padding: 7,
//     '& .MuiSwitch-switchBase': {
//       margin: 1,
//       padding: 0,
//       transform: 'translateX(6px)',
//       '&.Mui-checked': {
//         color: '#fff',
//         transform: 'translateX(22px)',
//         '& .MuiSwitch-thumb:before': {
//           backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent('#fff')}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
//         },
//         '& + .MuiSwitch-track': {
//           opacity: 1,
//           backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
//         },
//       },
//     },
//     '& .MuiSwitch-thumb': {
//       backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
//       width: 35,
//       height: 32,
//       '&::before': {
//         content: "''",
//         position: 'absolute',
//         width: '100%',
//         height: '100%',
//         left: 0,
//         top: 0,
//         backgroundRepeat: 'no-repeat',
//         backgroundPosition: 'center',
//         backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent('#fff')}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
//       },
//     },
//     '& .MuiSwitch-track': {
//       opacity: 1,
//       backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
//       borderRadius: 20 / 2,
//     },
//   }));

//   // 2. ننشئ كائنات القوائم الأساسية
//   const adminMenuItems = [
//     { text: 'Dashboard', icon: <GridViewIcon />, path: '/dashboard' },
//     { text: 'Leads', icon: <Person3OutlinedIcon />, path: '/AllLeadsForAdmin' },

//     // { text: "Home", icon: <HomeOutlinedIcon />, path: "/AllLeads" },
//     // {
//     //   text: "Leads",
//     //   icon: <Person3OutlinedIcon style={{color:"#6B7271"}}/>,
//     //   children: [
//     //     // { text: "Add Lead", path: "/addclient", icon: <PersonAddAltOutlinedIcon style={{color:"#6B7271"}}/> },
//     //     { text: "Manage Leads", path: "/AllLeads", icon: <PersonSearchOutlinedIcon style={{color:"#6B7271"}}/> },
//     //   //  { text: "Leads Trash", path: "/AllLeadsnotactivated", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> }

//     //   ]
//     // },
//     {
//       text: 'Inventory',
//       icon: <AssistantPhotoOutlinedIcon />,
//       children: [
//         { text: 'Projects', path: '/Project', icon: <AccountTreeOutlinedIcon /> },
//         { text: 'City', path: '/AllCitiesShow', icon: <ApartmentOutlinedIcon /> },
//         { text: 'Developers', path: '/Developers', icon: <HomeWorkOutlinedIcon /> },
//         { text: 'Region', path: '/Regionsandareas', icon: <LocationSearchingOutlinedIcon /> },
//         { text: 'Areas', path: '/Areas', icon: <AddLocationOutlinedIcon /> },
//       ],
//     },
//     // { text: "Stages", icon: <HorizontalSplitOutlinedIcon style={{color:"#6B7271"}}/>, path: "/Stages" },

//     {
//       text: 'Sales',
//       icon: <PersonOutlinedIcon />,
//       children: [
//         { text: 'Add Sales', path: '/Addsales', icon: <PersonAddAltOutlinedIcon /> },
//         { text: 'Manage Sales', path: '/sales', icon: <PersonSearchOutlinedIcon /> },
//       ],
//     },
//     // { text: "Channel", icon: <VideoSettingsOutlinedIcon style={{color:"#6B7271"}}/>, path: "/Channel" },
//     // {
//     //   text: "Regions Areas",
//     //   icon: <SouthAmericaIcon style={{color:"#6B7271"}}/>,
//     //   children: [
//     //     { text: "Region", path: "/Regionsandareas", icon: <LocationSearchingOutlinedIcon style={{color:"#6B7271"}}/> },
//     //     { text: "Areas", path: "/Areas", icon: <AddLocationOutlinedIcon style={{color:"#6B7271"}}/> }
//     //   ]
//     // },

//     // { text: "Communication Way", icon: <BubbleChartOutlinedIcon style={{color:"#6B7271"}}/>, path: "/Communicationway" },
//     // // { text: "Campaigns", icon: <CampaignOutlinedIcon style={{color:"#6B7271"}}/>, path: "/Campaigns" },
//     // { text: "Cancel Reason", icon: <DoNotDisturbAltOutlinedIcon style={{color:"#6B7271"}}/>, path: "/cancelreasons" },

//     {
//       text: 'Reporting',
//       icon: <AssessmentOutlinedIcon />,
//       children: [
//         { text: 'Marketing Reports', path: '/MarketingReports', icon: <AssessmentOutlinedIcon /> },
//         { text: 'Campaigns Reports', path: '/CampaignsReports', icon: <AssessmentOutlinedIcon /> },
//         // {
//         //   text: 'Collect Reports',
//         //   path: '/ImportantMarketingReports',
//         //   icon: <AssessmentOutlinedIcon />,
//         // },

//         // { text: "Facebook", path: "/Facebookintegration", icon: <FacebookIcon /> },
//         // { text: "More Integration", path: "/MoreIntegration", icon: <MoreIcon /> }
//       ],
//     },

//     {
//       text: 'Marketing',
//       icon: <CampaignOutlinedIcon />,
//       children: [
//         { text: 'Campaigns', icon: <CampaignOutlinedIcon />, path: '/Campaigns' },
//         { text: 'Channel', icon: <VideoSettingsOutlinedIcon />, path: '/Channel' },
//         {
//           text: 'Integration',
//           icon: <WebhookIcon />,
//           children: [
//             {
//               text: 'Webhook',
//               path: '/integration',
//               icon: <WebhookIcon />,
//             },
//             {
//               text: 'Facebook',
//               path: '/Facebookintegration',
//               icon: <FacebookIcon />,
//             },
//             {
//               text: 'More Integration',
//               path: '/MoreIntegration',
//               icon: <ExpandCircleDownOutlinedIcon />,
//             },
//           ],
//         },
//       ],
//     },
//     // {
//     //   text: "Integration",
//     //   icon: <WebhookIcon style={{color:"#6B7271"}}/>,
//     //   children: [
//     //     { text: "Webhook", path: "/integration", icon: <WebhookIcon style={{color:"#6B7271"}}/> },
//     //     { text: "Facebook", path: "/Facebookintegration", icon: <FacebookIcon style={{color:"#6B7271"}}/> },
//     //     { text: "More Integration", path: "/MoreIntegration", icon: <ExpandCircleDownOutlinedIcon style={{color:"#6B7271"}}/> }
//     //   ]
//     // },

//     {
//       text: 'Users',
//       icon: <PeopleAltOutlinedIcon />,
//       children: [
//         { text: 'Users', path: '/Users', icon: <PeopleAltOutlinedIcon /> },
//         // { text: "Users Activation", path: "/user_activation", icon: <AdminPanelSettingsOutlinedIcon /> },
//         { text: 'Rotaion', path: '/MoreRotation', icon: <ScreenRotationOutlinedIcon /> },
//         { text: 'Users Devices', path: '/AllUserDevices', icon: <ScreenRotationOutlinedIcon /> },
//       ],
//     },

//     {
//       text: 'Setting',
//       icon: <SettingsOutlinedIcon />,
//       children: [
//         {
//           text: 'Reports',
//           icon: <AssessmentIcon />,
//           children: [
//             {
//               text: 'Sales Report ',
//               path: '/SalesReportCountLeadsInMonths',
//               icon: <TrendingUpIcon />,
//             },
//             { text: 'Done Deal Report ', path: '/DoneDealReport', icon: <ChecklistIcon /> },
//             // { text: "Sales Leads Count Report ", path: "/salesreportcountleads", icon: <ChecklistIcon  /> },
//           ],
//         },

//         { text: 'Company Profile', path: '/CompanyProfile', icon: <SettingsOutlinedIcon /> },
//         { text: 'Stages', icon: <HorizontalSplitOutlinedIcon />, path: '/Stages' },
//         { text: 'Communication Way', icon: <BubbleChartOutlinedIcon />, path: '/Communicationway' },
//         { text: 'Cancel Reason', icon: <DoNotDisturbAltOutlinedIcon />, path: '/cancelreasons' },

//         {
//           text: 'Trash',
//           icon: <DeleteOutlineIcon />,
//           children: [
//             { text: 'Leads Trash ', path: '/AllLeadsnotactivated', icon: <DeleteOutlineIcon /> },
//             {
//               text: 'Stages Type Trash ',
//               path: '/AllStagesTypeTrash',
//               icon: <DeleteOutlineIcon />,
//             },
//             { text: 'Stages Trash', path: '/AllStagesTrash', icon: <DeleteOutlineIcon /> },
//             { text: 'Sales Trash', path: '/AllSalesTrash', icon: <DeleteOutlineIcon /> },
//             { text: 'Users Trash', path: '/AllUsersTrash', icon: <DeleteOutlineIcon /> },
//             { text: 'Comm Way Trash', path: '/AllCommWayTrash', icon: <DeleteOutlineIcon /> },
//             { text: 'Campaign  Trash', path: '/AllCampaignTrash', icon: <DeleteOutlineIcon /> },
//             { text: 'Developers  Trash', path: '/AllDevelopersTrash', icon: <DeleteOutlineIcon /> },
//             { text: 'Projects  Trash', path: '/AllProjectsTrash', icon: <DeleteOutlineIcon /> },
//             {
//               text: 'Cancel Reasons Trash',
//               path: '/CancelResanosTrash',
//               icon: <DeleteOutlineIcon />,
//             },

//             { text: 'Chanals Trash', path: '/ChanalsTrash', icon: <DeleteOutlineIcon /> },
//             { text: 'Regions Trash', path: '/RegionsTrash', icon: <DeleteOutlineIcon /> },
//             { text: 'Area Trash', path: '/AreaTrash', icon: <DeleteOutlineIcon /> },
//             { text: 'Cities Trash', path: '/CitiesTrash', icon: <DeleteOutlineIcon /> },
//           ],
//         },
//       ],
//     },

//     //   { text: "Users", path: "/Users", icon: <PeopleAltOutlinedIcon style={{color:"#6B7271"}}/> },
//     //   { text: "Users Activation", path: "/user_activation", icon: <AdminPanelSettingsOutlinedIcon style={{color:"#6B7271"}}/> },
//     //   { text: "Rotaion", path: "/Rotation", icon: <ScreenRotationAltIcon /> },
//     //   { text: "Rotaion", path: "/MoreRotation", icon: <ScreenRotationOutlinedIcon style={{color:"#6B7271"}}/> },
//     //   { text: "Company Profile", path: "/CompanyProfile", icon: <SettingsOutlinedIcon style={{color:"#6B7271"}}/> },

//     //    {
//     //     text: "Trash",
//     //     icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/>,
//     //     children: [
//     //       { text: "Leads Trash ", path: "/AllLeadsnotactivated", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //       { text: "Stages Type Trash ", path: "/AllStagesTypeTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //       { text: "Stages Trash", path: "/AllStagesTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //       { text: "Sales Trash", path: "/AllSalesTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //       { text: "Users Trash", path: "/AllUsersTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //        { text: "Comm Way Trash", path: "/AllCommWayTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //        { text: "Campaign  Trash", path: "/AllCampaignTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //        { text: "Developers  Trash", path: "/AllDevelopersTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //        { text: "Projects  Trash", path: "/AllProjectsTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //        { text: "Cancel Reasons Trash", path: "/CancelResanosTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },

//     //  { text: "Chanals Trash", path: "/ChanalsTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //  { text: "Regions Trash", path: "/RegionsTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //   { text: "Area Trash", path: "/AreaTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //    { text: "Cities Trash", path: "/CitiesTrash", icon: <DeleteOutlineIcon style={{color:"#6B7271"}}/> },
//     //     ]
//     //   },
//   ];

//   const salesMenuItems = [
//     { text: 'My Dashboard', path: '/SalesDashboard', icon: <GridViewIcon /> },
//     { text: 'My Leads', path: '/AllLeadsForSales', icon: <PersonSearchOutlinedIcon /> },
//     // { text: "My Account", path: "/MyAccount", icon: <AccountCircleIcon /> },
//     { text: 'Add Lead', path: '/addclient', icon: <PersonAddAltOutlinedIcon /> },
//   ];

//   const TeamLeaderMenuItems = [
//     { text: 'My Dashboard', path: '/TeamleaderDashboard', icon: <GridViewIcon /> },

//     { text: 'My Leads', path: '/AllLeadsForTeamLeader', icon: <PersonSearchOutlinedIcon /> },
//     // { text: "My Account", path: "/MyAccount", icon: <AccountCircleIcon /> },
//     { text: 'My Sales', path: '/TeamLeaderMysales', icon: <PersonPinOutlinedIcon /> },
//     { text: 'Add Lead', path: '/addclient', icon: <PersonAddAltOutlinedIcon /> },
//   ];

//   const ManagersMenuItems = [
//     { text: 'My Dashboard', path: '/ManagerDashboard', icon: <GridViewIcon /> },
//     { text: 'My Leads', path: '/LeadsForManagers', icon: <PersonPinOutlinedIcon /> },
//     // { text: "My Account", path: "/MyAccount", icon: <AccountCircleIcon /> },
//     {
//       text: 'My Team Leaders',
//       path: '/MyTeamLeadersForManagers',
//       icon: <SwitchAccountOutlinedIcon />,
//     },
//     {
//       text: 'My Team Analytics',
//       path: '/TeamAnalyticForManager',
//       icon: <StackedLineChartOutlinedIcon />,
//     },
//     { text: 'Add Lead', path: '/addclient', icon: <PersonAddAltOutlinedIcon /> },
//   ];

//   const AccountantMenuItems = [
//     { text: 'My Done Deals', path: '/LeadsForAccountant', icon: <Diversity3Icon /> },
//     { text: 'Sales Report', path: '/SalesMonyinMonthReportForAccountant', icon: <ShowChartIcon /> },
//     { text: 'Developers Account', path: '/DeveloperAccounts', icon: <AccountBoxIcon /> },
//     { text: 'Add Tasks', path: '/AccountantTasks', icon: <AddTaskIcon /> },
//     { text: 'Manage Tasks', path: '/ManageAccountantTasks', icon: <AssignmentIcon /> },
//     {
//       text: 'Inventory',
//       icon: <AssistantPhotoIcon />,
//       children: [
//         { text: 'Projects', path: '/Project', icon: <AssistantPhotoIcon /> },
//         { text: 'City', path: '/AddCity', icon: <WhereToVoteIcon /> },
//         { text: 'Developers', path: '/Developers', icon: <LoupeIcon /> },
//       ],
//     },
//   ];

//   const MarketerMenuItems = [
//     { text: 'Dashboard', icon: <GridViewIcon />, path: '/dashboard' },
//     // { text: "Home", icon: <HomeIcon />, path: "/LeadsForMarketer" },
//     {
//       text: 'Leads',
//       icon: <Person3OutlinedIcon />,
//       children: [
//         { text: 'Add Lead', path: '/addclient', icon: <PersonAddAltOutlinedIcon /> },
//         { text: 'Manage Leads', path: '/ALLLeadsForMarketer', icon: <PersonSearchOutlinedIcon /> },
//         // { text: "Leads Trash", path: "/AllLeadsnotactivated", icon: <DeleteOutlineIcon /> }
//       ],
//     },
//     {
//       text: 'Inventory',
//       icon: <AssistantPhotoOutlinedIcon />,
//       children: [
//         { text: 'Projects', path: '/Project', icon: <AccountTreeOutlinedIcon /> },
//         { text: 'City', path: '/AddCity', icon: <ApartmentOutlinedIcon /> },
//         { text: 'Developers', path: '/Developers', icon: <HomeWorkOutlinedIcon /> },
//       ],
//     },
//     // {
//     //   text: "Sales",
//     //   icon: <EmojiPeopleIcon />,
//     //   children: [
//     //     // { text: "Add Sales", path: "/Addsales", icon: <PersonAddIcon /> },
//     //     // { text: "Manage Sales", path: "/sales", icon: <Groups2Icon /> }
//     //   ]
//     // },

//     { text: 'Stages', icon: <HorizontalSplitOutlinedIcon />, path: '/Stages' },

//     { text: 'Channel', icon: <VideoSettingsOutlinedIcon />, path: '/Channel' },
//     {
//       text: 'Regions Areas',
//       icon: <SouthAmericaIcon />,
//       children: [
//         { text: 'Region', path: '/Regionsandareas', icon: <LocationSearchingOutlinedIcon /> },
//         { text: 'Areas', path: '/Areas', icon: <AddLocationOutlinedIcon /> },
//       ],
//     },

//     { text: 'Communication Way', icon: <BubbleChartOutlinedIcon />, path: '/Communicationway' },
//     { text: 'Campaigns', icon: <CampaignOutlinedIcon />, path: '/Campaigns' },
//     { text: 'Cancel Reason', icon: <DoNotDisturbAltOutlinedIcon />, path: '/cancelreasons' },

//     {
//       text: 'Reports',
//       icon: <AssessmentOutlinedIcon />,
//       children: [
//         { text: 'Marketing Reports', path: '/MarketingReports', icon: <AssessmentOutlinedIcon /> },
//         { text: 'Campaigns Reports', path: '/CampaignsReports', icon: <AssessmentOutlinedIcon /> },
//         // {
//         //   text: 'Collect Reports',
//         //   path: '/ImportantMarketingReports',
//         //   icon: <AssessmentOutlinedIcon />,
//         // },

//         // { text: "Facebook", path: "/Facebookintegration", icon: <FacebookIcon /> },
//         // { text: "More Integration", path: "/MoreIntegration", icon: <MoreIcon /> }
//       ],
//     },
//     {
//       text: 'Integration',
//       icon: <WebhookIcon />,
//       children: [
//         { text: 'Webhook', path: '/integration', icon: <WebhookIcon /> },
//         { text: 'Facebook', path: '/Facebookintegration', icon: <FacebookIcon /> },
//         {
//           text: 'More Integration',
//           path: '/MoreIntegration',
//           icon: <ExpandCircleDownOutlinedIcon />,
//         },
//       ],
//     },
//     // { text: "Users", path: "/Users", icon: <GroupIcon /> },
//     // { text: "Users Activation", path: "/user_activation", icon: <VerifiedUserIcon /> },
//     // { text: "Rotaion", path: "/Rotation", icon: <ScreenRotationAltIcon /> },
//     // { text: "Rotaion", path: "/MoreRotation", icon: <ScreenRotationOutlinedIcon style={{color:"#6B7271"}}/> },
//     // { text: "Company Profile", path: "/CompanyProfile", icon: <SettingsIcon /> },
//   ];

//   // ... باقي تعريفات القوائم

//   const getMenuItems = (user) => {
//     if (isAdminOrManager(user)) return adminMenuItems;
//     else if (isSales(user)) return salesMenuItems;
//     else if (isTeamLeader(user)) return TeamLeaderMenuItems;
//     else if (isManager(user)) return ManagersMenuItems;
//     else if (isAccountant(user)) return AccountantMenuItems;
//     else if (isMarketer(user)) return MarketerMenuItems;
//     return [];
//   };

//   const menuItems = getMenuItems(userlogin);

//   return (
//     <div
//       className="sidebar-container"
//       onMouseEnter={() => setOpen(true)}
//       onMouseLeave={() => setOpen(false)}
//     >
//       {isLoggedOut === 'true' ? (
//         <Drawer
//           sx={{
//             zIndex: (theme) => theme.zIndex.appBar - 1,
//             '& .MuiDrawer-paper': {
//               top: '65px',
//               height: 'calc(100% - 65px)',
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'space-between',
//               fontFamily: 'Montserrat',
//               overflowY: 'auto',
//               scrollbarWidth: 'none',
//               background: '#E7EBFF !important',
//               '&::-webkit-scrollbar': { display: 'none' },
//             },
//           }}
//           className={open ? 'drawer open heebo-bold' : 'drawer closed'}
//           open={openDrawer}
//           onClose={() => setOpenDrawer(false)}
//           variant={isMobile ? 'temporary' : 'persistent'}
//         >
//           <Box>
//             <List
//               sx={{
//                 overflowY: 'auto',
//                 scrollbarWidth: 'none',
//                 '&::-webkit-scrollbar': { display: 'none' },
//               }}
//             >
//               {menuItems.map((item, index) => (
//                 <div key={index}>
//                   {item.children ? (
//                     <>
//                       <ListItem
//                         button
//                         onClick={() => handleToggle(item.text)}
//                         sx={{
//                           position: 'relative',
//                           padding: '12px 16px',
//                           margin: '4px 8px',
//                           borderRadius: '4px',
//                           '&.Mui-selected, &.Mui-selected:hover': {
//                             '&::before': { backgroundColor: '#102dff' },
//                             '& .MuiTypography-root': { fontWeight: 600 },
//                             backgroundColor: 'transparent !important',
//                             color: '#666',
//                             '& .MuiListItemIcon-root': { color: '#666' },
//                           },
//                           '&::before': {
//                             content: '""',
//                             position: 'absolute',
//                             left: '8px',
//                             top: '12px',
//                             bottom: '12px',
//                             width: '4px',
//                             backgroundColor: isChildActive(item.children)
//                               ? '#102dff !important'
//                               : 'transparent',
//                             borderRadius: '0 2px 2px 0',
//                           },
//                           color: '#666',
//                           '& .MuiListItemIcon-root': { color: '#666' },
//                           '&:hover': { backgroundColor: 'rgba(16, 45, 255, 0.1)' },
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '12px',
//                           transition: 'all 0.2s ease',
//                         }}
//                         selected={isChildActive(item.children)}
//                       >
//                         {/* <ListItemIcon sx={{ minWidth: '40px', color: isChildActive ? 'white' : '#6B7271', transition: 'color 0.3s ease' }}> */}
//                         <ListItemIcon
//                           sx={{
//                             minWidth: '36px',
//                             marginRight: '2px',
//                             color: isChildActive(item.path) ? '#ffffff' : '#666',
//                             '& svg': {
//                               color: isChildActive(item.path) ? '#ffffff' : '#666',
//                             },
//                           }}
//                         >
//                           {item.icon}
//                         </ListItemIcon>
//                         {open && <ListItemText primary={item.text} />}
//                         {open && (openMenu[item.text] ? <ExpandLess /> : <ExpandMore />)}
//                       </ListItem>

//                       <Collapse in={openMenu[item.text]} timeout="auto" unmountOnExit>
//                         <List component="div" disablePadding>
//                           {item.children.map((child, childIndex) => (
//                             <div key={childIndex}>
//                               {child.children ? (
//                                 <>
//                                   {/* sub child main as integration ============================================= */}
//                                   <ListItem
//                                     button
//                                     onClick={() => handleToggle(child.text)}
//                                     sx={{
//                                       pl: 4,
//                                       padding: '12px 16px',
//                                       margin: '0 8px',
//                                       position: 'relative',
//                                       '&::before': {
//                                         content: '""',
//                                         position: 'absolute',
//                                         left: '8px',
//                                         top: '12px',
//                                         bottom: '12px',
//                                         width: '4px',
//                                         backgroundColor: isChildActive(child.children)
//                                           ? '#102dff !important'
//                                           : 'transparent',
//                                         borderRadius: '0 2px 2px 0',
//                                       },
//                                       '&:hover': { backgroundColor: 'rgba(16, 45, 255, 0.1)' },
//                                       display: 'flex',
//                                       alignItems: 'center',
//                                       gap: '12px',
//                                     }}
//                                     selected={isChildActive(child.children)}
//                                   >
//                                     <ListItemIcon
//                                       sx={{
//                                         minWidth: '36px',
//                                         marginRight: '2px',
//                                         color: isActive(child.path) ? '#ffffff' : '#666',
//                                         '& svg': {
//                                           color: isActive(child.path) ? '#ffffff' : '#666',
//                                         },
//                                       }}
//                                     >
//                                       {' '}
//                                       <span>{child.icon}</span>
//                                     </ListItemIcon>
//                                     <ListItemText primary={child.text} style={{ color: '#666' }} />
//                                     {openMenu[child.text] ? (
//                                       <ExpandLess style={{ color: '#666' }} />
//                                     ) : (
//                                       <ExpandMore style={{ color: '#666' }} />
//                                     )}
//                                   </ListItem>

//                                   <Collapse in={openMenu[child.text]} timeout="auto" unmountOnExit>
//                                     <List component="div" disablePadding>
//                                       {child.children.map((subChild, subChildIndex) => (
//                                         //  subchild  ============================
//                                         <div style={{ padding: '5px 5px' }}>
//                                           <ListItem
//                                             button
//                                             key={subChildIndex}
//                                             component={Link}
//                                             to={subChild.path}
//                                             sx={{
//                                               paddingY: '12px',

//                                               position: 'relative',
//                                               backgroundColor: isActive(subChild.path)
//                                                 ? '#102dff'
//                                                 : 'transparent',
//                                               color: isActive(subChild.path) ? '#ffffff' : '#666',
//                                               borderRadius: '8px',
//                                               '& .MuiListItemIcon-root': {
//                                                 color: isActive(subChild.path) ? '#ffffff' : '#666',
//                                               },
//                                               '&::before': {
//                                                 content: '""',
//                                                 position: 'absolute',
//                                                 left: '8px', // ← هنا دخلنا الشريط جوا شوية
//                                                 top: '8px',
//                                                 bottom: '8px',
//                                                 width: '4px',
//                                                 backgroundColor: isActive(subChild.path)
//                                                   ? '#102dff'
//                                                   : 'transparent',
//                                                 borderRadius: '0 4px 4px 0',
//                                               },
//                                               '&:hover': {
//                                                 backgroundColor: isActive(subChild.path)
//                                                   ? '#102dff'
//                                                   : 'rgba(16, 45, 255, 0.1)',
//                                               },
//                                             }}
//                                             selected={isActive(subChild.path)}
//                                           >
//                                             <ListItemIcon
//                                               sx={{
//                                                 minWidth: '36px',
//                                                 marginRight: '2px',
//                                                 color: isActive(subChild.path) ? '#102dff' : '#666',
//                                                 '& svg': {
//                                                   color: isActive(subChild.path)
//                                                     ? '#102dff'
//                                                     : '#666',
//                                                 },
//                                               }}
//                                             >
//                                               {subChild.icon}
//                                             </ListItemIcon>
//                                             <ListItemText
//                                               style={{
//                                                 color: isActive(subChild.path) ? '#102dff' : '#666',
//                                               }}
//                                               primary={subChild.text}
//                                             />
//                                           </ListItem>
//                                         </div>
//                                       ))}
//                                     </List>
//                                   </Collapse>
//                                 </>
//                               ) : (
//                                 // child ===>sub main
//                                 <div style={{ padding: '5px 5px' }}>
//                                   <ListItem
//                                     button
//                                     key={childIndex}
//                                     component={Link}
//                                     to={child.path}
//                                     sx={{
//                                       paddingY: '12px',

//                                       position: 'relative',
//                                       backgroundColor: isActive(child.path)
//                                         ? '#102dff'
//                                         : 'transparent',
//                                       color: isActive(child.path) ? '#102dff' : '#666',
//                                       borderRadius: '8px',
//                                       '& .MuiListItemIcon-root': {
//                                         color: isActive(child.path) ? '#102dff' : '#666',
//                                       },
//                                       '&::before': {
//                                         content: '""',
//                                         position: 'absolute',
//                                         left: '8px', // ← هنا دخلنا الشريط جوا شوية
//                                         top: '8px',
//                                         bottom: '8px',
//                                         width: '4px',
//                                         backgroundColor: isActive(child.path)
//                                           ? '#102dff'
//                                           : 'transparent',
//                                         borderRadius: '0 4px 4px 0',
//                                       },
//                                       '&:hover': {
//                                         backgroundColor: isActive(child.path)
//                                           ? '#102dff'
//                                           : 'rgba(16, 45, 255, 0.1)',
//                                       },
//                                     }}
//                                     selected={isActive(child.path)}
//                                   >
//                                     <ListItemIcon
//                                       sx={{
//                                         minWidth: '36px',
//                                         marginRight: '2px',
//                                         color: isActive(child.path) ? '#102dff' : '#666',
//                                         '& svg': {
//                                           color: isActive(child.path) ? '#102dff' : '#666',
//                                         },
//                                       }}
//                                     >
//                                       {child.icon}
//                                     </ListItemIcon>
//                                     <ListItemText primary={child.text} />
//                                   </ListItem>
//                                 </div>
//                                 // ==================================================================================
//                               )}
//                             </div>
//                           ))}
//                         </List>
//                       </Collapse>
//                     </>
//                   ) : (
//                     // leads and dashboard
//                     <div style={{ padding: '5px 5px' }}>
//                       {/* <ListItem
//                                             button
//                                             component={Link}
//                                             to={item.path}
//                                             sx={{
//                                                 position: 'relative',
//                                                 padding: '12px 16px',
//                                                 margin: '4px 8px',
//                                                 borderRadius: '4px',
//                                                      border:"2px solid red",

//                                                 '&.Mui-selected, &.Mui-selected:hover': {
//                                                     '&::before': { backgroundColor: '#102dff' },
//                                                     '& .MuiTypography-root': { fontWeight: 600 },
//                                                     backgroundColor: 'transparent !important',
//                                                     color: '#666',
//                                                     '& .MuiListItemIcon-root': { color: '#666' },
//                                                 },
//                                                 '&::before': {
//                                                     content: '""',
//                                                     position: 'absolute',
//                                                     left: '8px',
//                                                     top: '12px',
//                                                     bottom: '12px',
//                                                     width: '4px',
//                                                     backgroundColor: isActive(item.path) ? '#102dff' : 'transparent',
//                                                     borderRadius: '0 2px 2px 0',
//                                                 },
//                                                 color: '#666 !important',
//                                                 '& .MuiListItemIcon-root': { color: '#666' },
//                                                 '&:hover': { backgroundColor: 'rgba(16, 45, 255, 0.1)' },
//                                             }}
//                                             selected={isActive(item.path)}
//                                         >
//                                             <ListItemIcon
//   sx={{
//     minWidth: '36px',
//     marginRight: '2px',
//     color: isActive(item.path) ? '#ffffff' : '#666',
//     '& svg': {
//       color: isActive(item.path) ? '#ffffff' : '#666',
//     }
//   }}
// >
//                                                 {item.icon}
//                                             </ListItemIcon>
//                                             {open && <ListItemText primary={item.text} />}
//                                         </ListItem> */}

//                       <ListItem
//                         button
//                         // key={childIndex}
//                         component={Link}
//                         to={item.path}
//                         sx={{
//                           paddingY: '12px',

//                           position: 'relative',
//                           backgroundColor: isActive(item.path) ? '#102dff' : 'transparent',
//                           color: isActive(item.path) ? '#102dff' : '#666',
//                           borderRadius: '8px',
//                           '& .MuiListItemIcon-root': {
//                             color: isActive(item.path) ? '#102dff' : '#666',
//                           },
//                           '&::before': {
//                             content: '""',
//                             position: 'absolute',
//                             left: '8px', // ← هنا دخلنا الشريط جوا شوية
//                             top: '8px',
//                             bottom: '8px',
//                             width: '4px',
//                             backgroundColor: isActive(item.path) ? '#102dff' : 'transparent',
//                             borderRadius: '0 4px 4px 0',
//                           },
//                           '&:hover': {
//                             backgroundColor: isActive(item.path)
//                               ? '#102dff'
//                               : 'rgba(16, 45, 255, 0.1)',
//                           },
//                         }}
//                         selected={isActive(item.path)}
//                       >
//                         <ListItemIcon
//                           sx={{
//                             minWidth: '36px',
//                             marginRight: '2px',
//                             color: isActive(item.path) ? '#102dff' : '#666',
//                             '& svg': {
//                               color: isActive(item.path) ? '#102dff' : '#666',
//                             },
//                           }}
//                         >
//                           {item.icon}
//                         </ListItemIcon>
//                         {open && <ListItemText primary={item.text} />}
//                       </ListItem>
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </List>
//           </Box>

//           {/* ============================================================================ */}

//           {/* my account and log out and light and dark */}
//           {isPrivilegedRole && (
//             <Box sx={{ mt: 2, mb: 2, px: 1 }}>
//               <Divider />

//               <Box
//                 sx={{
//                   bgcolor: '#102dff',
//                   borderRadius: 2,
//                   py: 1,
//                   px: open ? 1.5 : 0.5,
//                   color: 'white',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'center', // أيقونات في النص
//                   gap: 1,
//                 }}
//               >
//                 {/* My Account */}
//                 <MenuItem
//                   onClick={() => navigate('/MyAccount')}
//                   sx={{
//                     color: 'white',
//                     minHeight: 40,
//                     width: '100%',
//                     justifyContent: open ? 'flex-start' : 'center', // أيقونات تتوسّط لما مقفول
//                   }}
//                 >
//                   <ListItemIcon
//                     sx={{
//                       color: 'white',
//                       minWidth: 0,
//                       justifyContent: 'center',
//                       mr: open ? 2 : 0,
//                     }}
//                   >
//                     <AccountCircleOutlinedIcon fontSize="small" />
//                   </ListItemIcon>
//                   {open && <ListItemText primary="My Account" />}
//                 </MenuItem>

//                 {/* Dark / Light Mode */}
//                 {/* <MenuItem
//         onClick={() => setmode(mode === "light" ? "dark" : "light")}
//         sx={{
//           color: "white",
//           minHeight: 40,
//           width: "100%",
//           justifyContent: open ? "flex-start" : "center",
//         }}
//       >
//         <ListItemIcon
//           sx={{
//             color: "white",
//             minWidth: 0,
//             justifyContent: "center",
//             mr: open ? 2 : 0,
//           }}
//         >
//           {theme.palette.mode === "dark" ? (
//             <DarkModeIcon  />
//           ) : (
//             <LightModeIcon  />
//           )}
//         </ListItemIcon>
//         {open && (
//           <ListItemText
//             primary={theme.palette.mode === "dark" ? "Dark Mode" : "Light Mode"}
//           />
//         )}
//       </MenuItem> */}

//                 {/* Logout */}
//                 <MenuItem
//                   // onClick={() => {
//                   //   localStorage.removeItem("user");
//                   //   navigate("/");
//                   // }}
//                   onClick={logout}
//                   sx={{
//                     color: 'white',
//                     minHeight: 40,
//                     width: '100%',
//                     justifyContent: open ? 'flex-start' : 'center',
//                   }}
//                 >
//                   <ListItemIcon
//                     sx={{
//                       color: 'white',
//                       minWidth: 0,
//                       justifyContent: 'center',
//                       mr: open ? 2 : 0,
//                     }}
//                   >
//                     <LogoutIcon fontSize="small" />
//                   </ListItemIcon>
//                   {open && <ListItemText primary="Logout" />}
//                 </MenuItem>
//               </Box>
//             </Box>
//           )}
//         </Drawer>
//       ) : (
//         () => setIsLoggedOut('false')
//       )}
//     </div>
//   );
// };
























// 20-5-2026
// import React, { useEffect, useState } from 'react';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { Logoutsession_one_Device } from '../Redux/Actions/Devices_Action';

// import {
//   Box, Drawer, List, ListItem, ListItemIcon, ListItemText,
//   Collapse, Typography, Tooltip,
// } from '@mui/material';

// import GridViewRoundedIcon           from '@mui/icons-material/GridViewRounded';
// import PeopleAltOutlinedIcon         from '@mui/icons-material/PeopleAltOutlined';
// import Inventory2OutlinedIcon        from '@mui/icons-material/Inventory2Outlined';
// import PersonOutlinedIcon            from '@mui/icons-material/PersonOutlined';
// import BarChartOutlinedIcon          from '@mui/icons-material/BarChartOutlined';
// import CampaignOutlinedIcon          from '@mui/icons-material/CampaignOutlined';
// import GroupsOutlinedIcon            from '@mui/icons-material/GroupsOutlined';
// import SettingsOutlinedIcon          from '@mui/icons-material/SettingsOutlined';
// import ShieldOutlinedIcon            from '@mui/icons-material/ShieldOutlined';
// import HelpOutlineIcon               from '@mui/icons-material/HelpOutline';
// import AddCircleOutlinedIcon         from '@mui/icons-material/AddCircleOutlined';
// import AccountCircleOutlinedIcon     from '@mui/icons-material/AccountCircleOutlined';
// import LogoutIcon                    from '@mui/icons-material/Logout';
// import ChevronLeftIcon               from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon              from '@mui/icons-material/ChevronRight';
// import { ExpandLess, ExpandMore }    from '@mui/icons-material';
// import AccountTreeOutlinedIcon       from '@mui/icons-material/AccountTreeOutlined';
// import ApartmentOutlinedIcon         from '@mui/icons-material/ApartmentOutlined';
// import HomeWorkOutlinedIcon          from '@mui/icons-material/HomeWorkOutlined';
// import LocationSearchingOutlinedIcon from '@mui/icons-material/LocationSearchingOutlined';
// import AddLocationOutlinedIcon       from '@mui/icons-material/AddLocationOutlined';
// import PersonAddAltOutlinedIcon      from '@mui/icons-material/PersonAddAltOutlined';
// import PersonSearchOutlinedIcon      from '@mui/icons-material/PersonSearchOutlined';
// import VideoSettingsOutlinedIcon     from '@mui/icons-material/VideoSettingsOutlined';
// import WebhookIcon                   from '@mui/icons-material/Webhook';
// import FacebookIcon                  from '@mui/icons-material/Facebook';
// import ExpandCircleDownOutlinedIcon  from '@mui/icons-material/ExpandCircleDownOutlined';
// import ScreenRotationOutlinedIcon    from '@mui/icons-material/ScreenRotationOutlined';
// import TrendingUpIcon                from '@mui/icons-material/TrendingUp';
// import ChecklistIcon                 from '@mui/icons-material/Checklist';
// import AssessmentIcon                from '@mui/icons-material/Assessment';
// import Language                      from '@mui/icons-material/Language';
// import HorizontalSplitOutlinedIcon   from '@mui/icons-material/HorizontalSplitOutlined';
// import BubbleChartOutlinedIcon       from '@mui/icons-material/BubbleChartOutlined';
// import DoNotDisturbAltOutlinedIcon   from '@mui/icons-material/DoNotDisturbAltOutlined';
// import DeleteOutlineIcon             from '@mui/icons-material/DeleteOutline';
// import PersonPinOutlinedIcon         from '@mui/icons-material/PersonPinOutlined';
// import SwitchAccountOutlinedIcon     from '@mui/icons-material/SwitchAccountOutlined';
// import StackedLineChartOutlinedIcon  from '@mui/icons-material/StackedLineChartOutlined';
// import Diversity3Icon                from '@mui/icons-material/Diversity3';
// import ShowChartIcon                 from '@mui/icons-material/ShowChart';
// import AccountBoxIcon                from '@mui/icons-material/AccountBox';
// import AddTaskIcon                   from '@mui/icons-material/AddTask';
// import AssignmentIcon                from '@mui/icons-material/Assignment';
// import AssistantPhotoIcon            from '@mui/icons-material/AssistantPhoto';
// import LoupeIcon                     from '@mui/icons-material/Loupe';
// import WhereToVoteIcon               from '@mui/icons-material/WhereToVote';
// import SouthAmericaIcon              from '@mui/icons-material/SouthAmerica';

// // ─── tokens ───────────────────────────────────────────────────────────────────
// const C = {
//   sidebarBg: '#F7F8FC',
//   topBg:     '#F7F8FC !important',
//   border:    '#E8EAF0',
//   accent:    '#1A3ECF !important',
//   text:      '#1C2340',
//   textMuted: '#7B829A !important',
//   hoverBg:   'rgba(26,62,207,0.04)',
//   ctaBg:     '#1A3ECF',
//   ctaHover:  '#1330A6 ',
//   divider:   '#E8EAF0',
// };

// const EXPANDED_WIDTH  = 242;
// const COLLAPSED_WIDTH = 64;

// // ─── menus ────────────────────────────────────────────────────────────────────
// const adminMenuItems = [
//   { text: 'Dashboard', icon: <GridViewRoundedIcon />,   path: '/dashboard' },
//   { text: 'Leads',     icon: <PeopleAltOutlinedIcon />, path: '/AllLeadsForAdmin' },
//   { text: 'Inventory', icon: <Inventory2OutlinedIcon />, children: [
//       { text: 'Projects',   path: '/Project',         icon: <AccountTreeOutlinedIcon /> },
//       { text: 'City',       path: '/AllCitiesShow',   icon: <ApartmentOutlinedIcon /> },
//       { text: 'Developers', path: '/Developers',      icon: <HomeWorkOutlinedIcon /> },
//       { text: 'Region',     path: '/Regionsandareas', icon: <LocationSearchingOutlinedIcon /> },
//       { text: 'Areas',      path: '/Areas',           icon: <AddLocationOutlinedIcon /> },
//   ]},
//   { text: 'Sales', icon: <PersonOutlinedIcon />, children: [
//       { text: 'Add Sales',    path: '/Addsales', icon: <PersonAddAltOutlinedIcon /> },
//       { text: 'Manage Sales', path: '/sales',    icon: <PersonSearchOutlinedIcon /> },
//   ]},
//   { text: 'Campaign Report', icon: <BarChartOutlinedIcon />, path: '/MarketingReports' },
//   { text: 'Marketing', icon: <CampaignOutlinedIcon />, children: [
//       { text: 'Campaigns',   icon: <CampaignOutlinedIcon />,      path: '/Campaigns' },
//       { text: 'Channel',     icon: <VideoSettingsOutlinedIcon />,  path: '/Channel' },
//       { text: 'Integration', icon: <WebhookIcon />, children: [
//           { text: 'Webhook',          path: '/integration',         icon: <WebhookIcon /> },
//           { text: 'Facebook',         path: '/Facebookintegration', icon: <FacebookIcon /> },
//           { text: 'More Integration', path: '/MoreIntegration',     icon: <ExpandCircleDownOutlinedIcon /> },
//       ]},
//   ]},
//   { text: 'Users', icon: <GroupsOutlinedIcon />, children: [
//       { text: 'Users',        path: '/Users',          icon: <PeopleAltOutlinedIcon /> },
//       { text: 'Rotation',     path: '/MoreRotation',   icon: <ScreenRotationOutlinedIcon /> },
//       { text: 'User Devices', path: '/AllUserDevices', icon: <ScreenRotationOutlinedIcon /> },
//   ]},
//   { text: 'Settings', icon: <SettingsOutlinedIcon />, children: [
//       { text: 'Reports', icon: <AssessmentIcon />, children: [
//           { text: 'Sales Report',     path: '/SalesReportCountLeadsInMonths', icon: <TrendingUpIcon /> },
//           { text: 'Done Deal Report', path: '/DoneDealReport',                icon: <ChecklistIcon /> },
//       ]},
//       { text: 'Company Profile',   path: '/CompanyProfile',   icon: <SettingsOutlinedIcon /> },
//       { text: 'Company Domains',   path: '/CompanyDomains',   icon: <Language /> },
//       { text: 'Stages',            path: '/Stages',           icon: <HorizontalSplitOutlinedIcon /> },
//       { text: 'Communication Way', path: '/Communicationway', icon: <BubbleChartOutlinedIcon /> },
//       { text: 'Cancel Reason',     path: '/cancelreasons',    icon: <DoNotDisturbAltOutlinedIcon /> },
//       { text: 'Trash', icon: <DeleteOutlineIcon />, children: [
//           { text: 'Leads Trash',          path: '/AllLeadsnotactivated', icon: <DeleteOutlineIcon /> },
//           { text: 'Stages Type Trash',    path: '/AllStagesTypeTrash',   icon: <DeleteOutlineIcon /> },
//           { text: 'Stages Trash',         path: '/AllStagesTrash',       icon: <DeleteOutlineIcon /> },
//           { text: 'Sales Trash',          path: '/AllSalesTrash',        icon: <DeleteOutlineIcon /> },
//           { text: 'Users Trash',          path: '/AllUsersTrash',        icon: <DeleteOutlineIcon /> },
//           { text: 'Comm Way Trash',       path: '/AllCommWayTrash',      icon: <DeleteOutlineIcon /> },
//           { text: 'Campaign Trash',       path: '/AllCampaignTrash',     icon: <DeleteOutlineIcon /> },
//           { text: 'Developers Trash',     path: '/AllDevelopersTrash',   icon: <DeleteOutlineIcon /> },
//           { text: 'Projects Trash',       path: '/AllProjectsTrash',     icon: <DeleteOutlineIcon /> },
//           { text: 'Cancel Reasons Trash', path: '/CancelResanosTrash',   icon: <DeleteOutlineIcon /> },
//           { text: 'Channels Trash',       path: '/ChanalsTrash',         icon: <DeleteOutlineIcon /> },
//           { text: 'Regions Trash',        path: '/RegionsTrash',         icon: <DeleteOutlineIcon /> },
//           { text: 'Area Trash',           path: '/AreaTrash',            icon: <DeleteOutlineIcon /> },
//           { text: 'Cities Trash',         path: '/CitiesTrash',          icon: <DeleteOutlineIcon /> },
//       ]},
//   ]},
// ];

// const salesMenuItems = [
//   { text: 'My Dashboard', path: '/SalesDashboard',   icon: <GridViewRoundedIcon /> },
//   { text: 'My Leads',     path: '/AllLeadsForSales', icon: <PeopleAltOutlinedIcon /> },
//   { text: 'Add Lead',     path: '/addclient',        icon: <PersonAddAltOutlinedIcon /> },
// ];
// const teamLeaderMenuItems = [
//   { text: 'My Dashboard', path: '/TeamleaderDashboard',   icon: <GridViewRoundedIcon /> },
//   { text: 'My Leads',     path: '/AllLeadsForTeamLeader', icon: <PeopleAltOutlinedIcon /> },
//   { text: 'My Sales',     path: '/TeamLeaderMysales',     icon: <PersonPinOutlinedIcon /> },
//   { text: 'Add Lead',     path: '/addclient',             icon: <PersonAddAltOutlinedIcon /> },
// ];
// const managerMenuItems = [
//   { text: 'My Dashboard',      path: '/ManagerDashboard',         icon: <GridViewRoundedIcon /> },
//   { text: 'My Leads',          path: '/LeadsForManagers',         icon: <PeopleAltOutlinedIcon /> },
//   { text: 'My Team Leaders',   path: '/MyTeamLeadersForManagers', icon: <SwitchAccountOutlinedIcon /> },
//   { text: 'My Team Analytics', path: '/TeamAnalyticForManager',   icon: <StackedLineChartOutlinedIcon /> },
//   { text: 'Add Lead',          path: '/addclient',                icon: <PersonAddAltOutlinedIcon /> },
// ];
// const accountantMenuItems = [
//   { text: 'My Done Deals',      path: '/LeadsForAccountant',                  icon: <Diversity3Icon /> },
//   { text: 'Sales Report',       path: '/SalesMonyinMonthReportForAccountant', icon: <ShowChartIcon /> },
//   { text: 'Developers Account', path: '/DeveloperAccounts',                   icon: <AccountBoxIcon /> },
//   { text: 'Add Tasks',          path: '/AccountantTasks',                     icon: <AddTaskIcon /> },
//   { text: 'Manage Tasks',       path: '/ManageAccountantTasks',               icon: <AssignmentIcon /> },
//   { text: 'Inventory', icon: <Inventory2OutlinedIcon />, children: [
//       { text: 'Projects',   path: '/Project',    icon: <AssistantPhotoIcon /> },
//       { text: 'City',       path: '/AddCity',    icon: <WhereToVoteIcon /> },
//       { text: 'Developers', path: '/Developers', icon: <LoupeIcon /> },
//   ]},
// ];
// const marketerMenuItems = [
//   { text: 'Dashboard', path: '/dashboard', icon: <GridViewRoundedIcon /> },
//     { text: 'Leads', path: '/ALLLeadsForMarketer', icon: <PersonSearchOutlinedIcon /> },

//   // { text: 'Leads', icon: <PeopleAltOutlinedIcon />, children: [
//   //     { text: 'Add Lead',     path: '/addclient',           icon: <PersonAddAltOutlinedIcon /> },
//   //     { text: 'Manage Leads', path: '/ALLLeadsForMarketer', icon: <PersonSearchOutlinedIcon /> },
//   // ]},
//   { text: 'Inventory', icon: <Inventory2OutlinedIcon />, children: [
//       { text: 'Projects',   path: '/Project',    icon: <AccountTreeOutlinedIcon /> },
//       { text: 'City',       path: '/AddCity',    icon: <ApartmentOutlinedIcon /> },
//       { text: 'Developers', path: '/Developers', icon: <HomeWorkOutlinedIcon /> },
//   ]},
//   { text: 'Stages',            icon: <HorizontalSplitOutlinedIcon />, path: '/Stages' },
//   { text: 'Channel',           icon: <VideoSettingsOutlinedIcon />,   path: '/Channel' },
//   { text: 'Regions & Areas', icon: <SouthAmericaIcon />, children: [
//       { text: 'Region', path: '/Regionsandareas', icon: <LocationSearchingOutlinedIcon /> },
//       { text: 'Areas',  path: '/Areas',           icon: <AddLocationOutlinedIcon /> },
//   ]},
//   { text: 'Communication Way', icon: <BubbleChartOutlinedIcon />,     path: '/Communicationway' },
//   { text: 'Campaigns',         icon: <CampaignOutlinedIcon />,        path: '/Campaigns' },
//   { text: 'Cancel Reason',     icon: <DoNotDisturbAltOutlinedIcon />, path: '/cancelreasons' },
//   { text: 'Reports', icon: <BarChartOutlinedIcon />, children: [
//       { text: 'Marketing Reports', path: '/MarketingReports',          icon: <BarChartOutlinedIcon /> },
//       { text: 'Campaigns Reports', path: '/CampaignsReports',          icon: <BarChartOutlinedIcon /> },
//       { text: 'Collect Reports',   path: '/ImportantMarketingReports', icon: <BarChartOutlinedIcon /> },
//   ]},
//   { text: 'Integration', icon: <WebhookIcon />, children: [
//       { text: 'Webhook',          path: '/integration',         icon: <WebhookIcon /> },
//       { text: 'Facebook',         path: '/Facebookintegration', icon: <FacebookIcon /> },
//       { text: 'More Integration', path: '/MoreIntegration',     icon: <ExpandCircleDownOutlinedIcon /> },
//   ]},
// ];

// const menuMap = {
//   Admin: adminMenuItems, Sales: salesMenuItems,
//   'Team Leader': teamLeaderMenuItems, Manager: managerMenuItems,
//   Accountant: accountantMenuItems,   Marketer: marketerMenuItems,
// };

// // ─── helpers ──────────────────────────────────────────────────────────────────
// const hasActiveChild = (node, pathname) => {
//   if (node.path) return pathname === node.path;
//   return node.children?.some(c => hasActiveChild(c, pathname));
// };

// // ─── NavLeaf ──────────────────────────────────────────────────────────────────
// const NavLeaf = ({ item, depth, expanded, onExpand }) => {
//   const { pathname } = useLocation();
//   const active = pathname === item.path;

//   const inner = (
//     <ListItem button component={Link} to={item.path}
//       onClick={() => { if (!expanded) onExpand(); }}
//       sx={{
//         pl: expanded ? `${16 + depth * 14}px` : 0,
//         pr: expanded ? '12px' : 0,
//         py: '10px',
//         mx: expanded ? '8px' : '6px',
//         width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
//         borderRadius: '8px', mb: '2px',
//         position: 'relative',
//         justifyContent: expanded ? 'flex-start' : 'center',
//         bgcolor: active ? '#FFFFFF' : 'transparent',
//         boxShadow: active ? '0 1px 6px rgba(0,0,0,0.08)' : 'none',
//         transition: 'all 0.2s',
//         '&:hover': { bgcolor: active ? '#FFFFFF' : C.hoverBg },
//         '&::before': active && expanded ? {
//           content: '""', position: 'absolute',
//           left: 0, top: '18%', bottom: '18%',
//           width: '3px', bgcolor: C.accent,
//           borderRadius: '0 3px 3px 0',
//         } : {},
//       }}
//     >
//       <ListItemIcon sx={{
//         minWidth: 0, mr: expanded ? '10px' : 0,
//         color: active ? C.accent : C.textMuted,
//         '& svg': { fontSize: '20px' },
//         transition: 'color 0.15s',
//         justifyContent: 'center',
//       }}>
//         {item.icon}
//       </ListItemIcon>
//       {expanded && (
//         <ListItemText primary={item.text} primaryTypographyProps={{
//           fontSize: depth === 0 ? '13.5px' : '13px',
//           fontWeight: active ? 600 : 400,
//           color: active ? C.accent : (depth > 0 ? C.textMuted : C.text),
//           fontFamily: "'DM Sans', sans-serif",
//         }} />
//       )}
//     </ListItem>
//   );

//   return expanded ? inner : <Tooltip title={item.text} placement="right" arrow>{inner}</Tooltip>;
// };

// // ─── NavGroup ─────────────────────────────────────────────────────────────────
// const NavGroup = ({ item, depth, expanded, onExpand }) => {
//   const { pathname } = useLocation();
//   const childActive = hasActiveChild(item, pathname);
//   const [open, setOpen] = useState(false);

//   useEffect(() => { if (childActive && expanded) setOpen(true); }, [pathname, expanded]);
//   useEffect(() => { if (!expanded) setOpen(false); }, [expanded]);

//   const handleClick = () => {
//     if (!expanded) { onExpand(); return; }
//     setOpen(p => !p);
//   };

//   const inner = (
//     <ListItem button onClick={handleClick}
//       sx={{
//         pl: expanded ? `${16 + depth * 14}px` : 0,
//         pr: expanded ? '12px' : 0,
//         py: '10px',
//         mx: expanded ? '8px' : '6px',
//         width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
//         borderRadius: '8px', mb: '2px',
//         justifyContent: expanded ? 'flex-start' : 'center',
//         bgcolor: childActive && !open && expanded ? 'rgba(26,62,207,0.06)' : 'transparent',
//         transition: 'all 0.2s',
//         '&:hover': { bgcolor: C.hoverBg },
//       }}
//     >
//       <ListItemIcon sx={{
//         minWidth: 0, mr: expanded ? '10px' : 0,
//         color: childActive ? C.accent : C.textMuted,
//         '& svg': { fontSize: '20px' },
//         transition: 'color 0.15s',
//         justifyContent: 'center',
//       }}>
//         {item.icon}
//       </ListItemIcon>
//       {expanded && (
//         <>
//           <ListItemText primary={item.text} primaryTypographyProps={{
//             fontSize: depth === 0 ? '13.5px' : '13px',
//             fontWeight: childActive ? 600 : 400,
//             color: childActive ? C.accent : (depth > 0 ? C.textMuted : C.text),
//             fontFamily: "'DM Sans', sans-serif",
//           }} />
//           {open
//             ? <ExpandLess sx={{ fontSize: '16px', color: C.textMuted }} />
//             : <ExpandMore sx={{ fontSize: '16px', color: C.textMuted }} />}
//         </>
//       )}
//     </ListItem>
//   );

//   return (
//     <>
//       {expanded ? inner : <Tooltip title={item.text} placement="right" arrow>{inner}</Tooltip>}
//       {expanded && (
//         <Collapse in={open} timeout={180} unmountOnExit>
//           {depth === 0 ? (
//             <Box sx={{ ml: '34px', borderLeft: `1.5px solid ${C.border}`, my: '2px', pl: '2px' }}>
//               <List disablePadding>
//                 {item.children.map((child, i) =>
//                   child.children
//                     ? <NavGroup key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
//                     : <NavLeaf  key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
//                 )}
//               </List>
//             </Box>
//           ) : (
//             <List disablePadding sx={{ pl: '6px' }}>
//               {item.children.map((child, i) =>
//                 child.children
//                   ? <NavGroup key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
//                   : <NavLeaf  key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
//               )}
//             </List>
//           )}
//         </Collapse>
//       )}
//     </>
//   );
// };

// // ─── FooterRow ────────────────────────────────────────────────────────────────
// const FooterRow = ({ icon, label, onClick, danger, expanded }) => {
//   const inner = (
//     <ListItem button onClick={onClick}
//       sx={{
//         px: expanded ? '12px' : 0, py: '9px',
//         mx: expanded ? '8px' : '6px',
//         width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
//         borderRadius: '8px', mb: '1px',
//         justifyContent: expanded ? 'flex-start' : 'center',
//         gap: expanded ? '10px' : 0,
//         transition: 'all 0.2s',
//         '&:hover': { bgcolor: danger ? 'rgba(239,68,68,0.06)' : C.hoverBg },
//         '&:hover .fi': { color: danger ? '#EF4444' : C.text },
//         '&:hover .fl': { color: danger ? '#EF4444' : C.text },
//       }}
//     >
//       <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center', '& svg': { fontSize: '19px' } }}>
//         <Box component="span" className="fi"
//           sx={{ color: C.textMuted, display: 'flex', transition: 'color 0.15s' }}>
//           {icon}
//         </Box>
//       </ListItemIcon>
//       {expanded && (
//         <ListItemText className="fl" primary={label} primaryTypographyProps={{
//           fontSize: '13.5px', fontWeight: 400, color: C.text,
//           fontFamily: "'DM Sans', sans-serif",
//           sx: { transition: 'color 0.15s' },
//         }} />
//       )}
//     </ListItem>
//   );
//   return expanded ? inner : <Tooltip title={label} placement="right" arrow>{inner}</Tooltip>;
// };

// // ─── Main ─────────────────────────────────────────────────────────────────────
// export const Leftsidebare2 = ({ setmode, mode, openDrawer, isMobile, toggleDrawer, setOpenDrawer, onExpandedChange }) => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [expanded,      setExpanded]      = useState(true);
//   const [userlogin,     setUserlogin]     = useState(null);
//   const [loadinglogout, setLoadinglogout] = useState(true);
//   const [isLoggedOut,   setIsLoggedOut]   = useState(localStorage.getItem('isLoggedIn'));
//   const savedDeviceId = localStorage.getItem('deviceId');

//   // ✅ الفرق الوحيد — function واحدة بتعمل expand وبتحفظ في localStorage
//   // بيتبعتها لـ NavLeaf و NavGroup عشان لما يضغط على أيقون وهو collapsed
//   // يفتح الـ sidebar ويحدث الـ event ويحفظ الحالة كلها صح
//   const handleExpand = () => {
//     setExpanded(true);
//     localStorage.setItem('sidebarExpanded', 'true');
//   };

//   // notify parent + broadcast event لكل صفحة بتستمع
//   useEffect(() => {
//     if (typeof onExpandedChange === 'function') onExpandedChange(expanded);
//     window.dispatchEvent(new CustomEvent('sidebarResized', {
//       detail: { width: expanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH }
//     }));
//   }, [expanded]);

//   useEffect(() => {
//     const u = JSON.parse(localStorage.getItem('user'));
//     if (u) setUserlogin(u);
//   }, []);

//   useEffect(() => {
//     const path = location.pathname;
//     const hide = path === '/' || path === '/Login';
//     if (typeof setOpenDrawer === 'function') setOpenDrawer(!hide);
//     const nb = document.getElementById('navbarr');
//     if (nb) nb.style.display = hide ? 'none' : 'flex';
//   }, [location.pathname, setOpenDrawer]);

//   const logout = async () => {
//     setLoadinglogout(true);
//     await dispatch(Logoutsession_one_Device(userlogin?.data?._id, savedDeviceId));
//     setLoadinglogout(false);
//   };

//   useEffect(() => {
//     if (!loadinglogout) {
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       localStorage.setItem('isLoggedIn', 'false');
//       window.location.href = '#/';
//     }
//   }, [loadinglogout]);

//   const role         = userlogin?.data?.role;
//   const menuItems    = menuMap[role] || [];
//   const isPrivileged = ['Sales','Team Leader','Manager','Admin','Marketer','Accountant'].includes(role);
//   const drawerWidth  = expanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH;

//   if (isLoggedOut !== 'true') return null;

//   const content = (
//     <Box sx={{
//       display: 'flex', flexDirection: 'column',
//       height: '100%', bgcolor: C.sidebarBg,
//       width: drawerWidth,
//       transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)',
//       overflow: 'hidden',
//     }}>

//       {/* ── Brand + toggle ── */}
//       <Box sx={{
//         height: '64px',
//         px: expanded ? 2.5 : 0,
//         display: 'flex', alignItems: 'center',
//         justifyContent: expanded ? 'space-between' : 'center',
//         bgcolor: C.topBg,
//         borderBottom: `1px solid ${C.border}`,
//         flexShrink: 0,
//       }}>
//         {expanded && (
//           <Box>
//             <Typography sx={{
//               fontFamily: "'DM Sans', sans-serif", fontWeight: 800, fontSize: '12.5px',
//               color: C.accent, letterSpacing: '0.13em', textTransform: 'uppercase',
//               lineHeight: 1.3, whiteSpace: 'nowrap',
//             }}>
//               Realatix CRM
//             </Typography>
//             <Typography sx={{
//               fontFamily: "'DM Sans', sans-serif", fontWeight: 400, fontSize: '9px',
//               color: C.textMuted, letterSpacing: '0.15em',
//               textTransform: 'uppercase', whiteSpace: 'nowrap',
//             }}>
//               Elite Tier Access
//             </Typography>
//           </Box>
//         )}

//         {/* ← → toggle button — بيحفظ في localStorage */}
//         <Tooltip title={expanded ? 'Collapse' : 'Expand'} placement="right">
//           <Box
//             onClick={() => setExpanded(p => {
//               const next = !p;
//               localStorage.setItem('sidebarExpanded', String(next));
//               return next;
//             })}
//             sx={{
//               width: 28, height: 28, borderRadius: '6px',
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//               cursor: 'pointer', flexShrink: 0,
//               color: C.textMuted,
//               border: `1px solid ${C.border}`,
//               bgcolor: '#fff',
//               transition: 'all 0.15s',
//               '&:hover': { color: C.accent, borderColor: C.accent, bgcolor: 'rgba(26,62,207,0.04)' },
//             }}
//           >
//             {expanded
//               ? <ChevronLeftIcon  sx={{ fontSize: '17px' }} />
//               : <ChevronRightIcon sx={{ fontSize: '17px' }} />}
//           </Box>
//         </Tooltip>
//       </Box>

//       {/* ── Nav ── */}
//       <Box sx={{
//         flex: 1, overflowY: 'auto', overflowX: 'hidden', py: '10px',
//         scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' },
//       }}>
//         <List disablePadding>
//           {menuItems.map((item, i) =>
//             item.children
//               ? <NavGroup key={i} item={item} depth={0} expanded={expanded} onExpand={handleExpand} />
//               : <NavLeaf  key={i} item={item} depth={0} expanded={expanded} onExpand={handleExpand} />
//           )}
//         </List>
//       </Box>

//       {/* ── CTA ── */}
//       <Box sx={{ px: expanded ? 1.5 : '6px', pb: 1, flexShrink: 0 }}>
//         {expanded ? (
//           <Box onClick={() => navigate('/addclient')} sx={{
//             bgcolor: '#0D47A1', color: '#fff', borderRadius: '8px', py: '11px',
//             display: 'flex', alignItems: 'center', justifyContent: 'center',
//             gap: '7px', cursor: 'pointer',
//             fontFamily: "'DM Sans', sans-serif", fontSize: '12px', fontWeight: 700,
//             letterSpacing: '0.1em', textTransform: 'uppercase',
//             boxShadow: '0 2px 10px rgba(26,62,207,0.22)',
//             transition: 'background 0.15s, box-shadow 0.15s',
//             '&:hover': { bgcolor: C.ctaHover },
//             '&:active': { transform: 'scale(0.98)' },
//           }}>
//             <AddCircleOutlinedIcon sx={{ fontSize: '16px' }} />
//             Create New Lead
//           </Box>
//         ) : (
//           <Tooltip title="New Listing" placement="right">
//             <Box onClick={() => navigate('/addclient')} sx={{
//               bgcolor: C.ctaBg, color: '#fff', borderRadius: '8px', py: '10px',
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//               cursor: 'pointer', boxShadow: '0 2px 10px rgba(26,62,207,0.22)',
//               '&:hover': { bgcolor: C.ctaHover },
//             }}>
//               <AddCircleOutlinedIcon sx={{ fontSize: '20px' }} />
//             </Box>
//           </Tooltip>
//         )}
//       </Box>

//       {/* ── Footer ── */}
//       {isPrivileged && (
//         <Box sx={{ borderTop: `1px solid ${C.divider}`, pt: '6px', pb: '10px', flexShrink: 0 }}>
//           {/* <FooterRow icon={<ShieldOutlinedIcon />}        label="Security" onClick={() => navigate('/security')}  expanded={expanded} /> */}
//           <FooterRow icon={<HelpOutlineIcon />}           label="Support"  onClick={() => navigate('/support')}   expanded={expanded} />
//           <FooterRow icon={<AccountCircleOutlinedIcon />} label="Account"  onClick={() => navigate('/MyAccount')} expanded={expanded} />
//           <FooterRow icon={<LogoutIcon />}                label="Logout"   onClick={logout} danger expanded={expanded} />
//         </Box>
//       )}
//     </Box>
//   );

//   return (
//     <Drawer
//       variant={isMobile ? 'temporary' : 'persistent'}
//       open={openDrawer}
//       onClose={() => setOpenDrawer(false)}
//       sx={{
//         width: drawerWidth,
//         flexShrink: 0,
//         transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)',
//         zIndex: (t) => t.zIndex.appBar,
//         '& .MuiDrawer-paper': {
//           width: drawerWidth,
//           top: 0, height: '100vh',
//           border: 'none',
//           borderRight: `1px solid ${C.border}`,
//           overflowX: 'hidden',
//           bgcolor: C.sidebarBg,
//           transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)',
//         },
//       }}
//     >
//       {content}
//     </Drawer>
//   );
// };


















// after 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Logoutsession_one_Device } from '../Redux/Actions/Devices_Action';

import {
  Box, Drawer, List, ListItem, ListItemIcon, ListItemText,
  Collapse, Typography, Tooltip,
} from '@mui/material';

import GridViewRoundedIcon           from '@mui/icons-material/GridViewRounded';
import PeopleAltOutlinedIcon         from '@mui/icons-material/PeopleAltOutlined';
import Inventory2OutlinedIcon        from '@mui/icons-material/Inventory2Outlined';
import PersonOutlinedIcon            from '@mui/icons-material/PersonOutlined';
import BarChartOutlinedIcon          from '@mui/icons-material/BarChartOutlined';
import CampaignOutlinedIcon          from '@mui/icons-material/CampaignOutlined';
import GroupsOutlinedIcon            from '@mui/icons-material/GroupsOutlined';
import SettingsOutlinedIcon          from '@mui/icons-material/SettingsOutlined';
import ShieldOutlinedIcon            from '@mui/icons-material/ShieldOutlined';
import HelpOutlineIcon               from '@mui/icons-material/HelpOutline';
import AddCircleOutlinedIcon         from '@mui/icons-material/AddCircleOutlined';
import AccountCircleOutlinedIcon     from '@mui/icons-material/AccountCircleOutlined';
import LogoutIcon                    from '@mui/icons-material/Logout';
import ChevronLeftIcon               from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon              from '@mui/icons-material/ChevronRight';
import { ExpandLess, ExpandMore }    from '@mui/icons-material';
import AccountTreeOutlinedIcon       from '@mui/icons-material/AccountTreeOutlined';
import ApartmentOutlinedIcon         from '@mui/icons-material/ApartmentOutlined';
import HomeWorkOutlinedIcon          from '@mui/icons-material/HomeWorkOutlined';
import LocationSearchingOutlinedIcon from '@mui/icons-material/LocationSearchingOutlined';
import AddLocationOutlinedIcon       from '@mui/icons-material/AddLocationOutlined';
import PersonAddAltOutlinedIcon      from '@mui/icons-material/PersonAddAltOutlined';
import PersonSearchOutlinedIcon      from '@mui/icons-material/PersonSearchOutlined';
import VideoSettingsOutlinedIcon     from '@mui/icons-material/VideoSettingsOutlined';
import WebhookIcon                   from '@mui/icons-material/Webhook';
import FacebookIcon                  from '@mui/icons-material/Facebook';
import ExpandCircleDownOutlinedIcon  from '@mui/icons-material/ExpandCircleDownOutlined';
import ScreenRotationOutlinedIcon    from '@mui/icons-material/ScreenRotationOutlined';
import TrendingUpIcon                from '@mui/icons-material/TrendingUp';
import ChecklistIcon                 from '@mui/icons-material/Checklist';
import AssessmentIcon                from '@mui/icons-material/Assessment';
import Language                      from '@mui/icons-material/Language';
import HorizontalSplitOutlinedIcon   from '@mui/icons-material/HorizontalSplitOutlined';
import BubbleChartOutlinedIcon       from '@mui/icons-material/BubbleChartOutlined';
import DoNotDisturbAltOutlinedIcon   from '@mui/icons-material/DoNotDisturbAltOutlined';
import DeleteOutlineIcon             from '@mui/icons-material/DeleteOutline';
import PersonPinOutlinedIcon         from '@mui/icons-material/PersonPinOutlined';
import SwitchAccountOutlinedIcon     from '@mui/icons-material/SwitchAccountOutlined';
import StackedLineChartOutlinedIcon  from '@mui/icons-material/StackedLineChartOutlined';
import Diversity3Icon                from '@mui/icons-material/Diversity3';
import ShowChartIcon                 from '@mui/icons-material/ShowChart';
import AccountBoxIcon                from '@mui/icons-material/AccountBox';
import AddTaskIcon                   from '@mui/icons-material/AddTask';
import AssignmentIcon                from '@mui/icons-material/Assignment';
import AssistantPhotoIcon            from '@mui/icons-material/AssistantPhoto';
import LoupeIcon                     from '@mui/icons-material/Loupe';
import WhereToVoteIcon               from '@mui/icons-material/WhereToVote';
import SouthAmericaIcon              from '@mui/icons-material/SouthAmerica';
import ArrowBackOutlinedIcon         from '@mui/icons-material/ArrowBackOutlined';
import StorageOutlinedIcon           from '@mui/icons-material/StorageOutlined';

// ─── tokens ───────────────────────────────────────────────────────────────────
const C = {
  sidebarBg: '#F7F8FC',
  topBg:     '#F7F8FC !important',
  border:    '#E8EAF0',
  accent:    '#1A3ECF !important',
  text:      '#1C2340',
  textMuted: '#7B829A !important',
  hoverBg:   'rgba(26,62,207,0.04)',
  ctaBg:     '#1A3ECF',
  ctaHover:  '#1330A6 ',
  divider:   '#E8EAF0',
};

const EXPANDED_WIDTH  = 242;
const COLLAPSED_WIDTH = 64;

// ─── Data Center routes per role ──────────────────────────────────────────────
const DATA_CENTER_ROUTES = {
  Admin:         { dashboard: '/AllLeadsForAdminCRMDataQuickNumbers', leads: '/AllLeadsForAdminCRMDatapage',    returnTo: '/AllLeadsForAdmin' },
  'Team Leader': { dashboard: '/TeamLeaderQuickNumbersCRMData',       leads: '/TeamLeaderCRMDATAALLLeads',      returnTo: '/AllLeadsForTeamLeader' },
  Sales:         { dashboard: '/SalesQuickNumberCRMData',             leads: '/SalesAllLeadsCRMDATA',           returnTo: '/AllLeadsForSales' },
  Marketer:      { dashboard: '/QuickNumbersForMarketerCRMDATA',      leads: '/ALLLeadsForMarketerCRMDATA',     returnTo: '/ALLLeadsForMarketer' },
  Manager:       { dashboard: '/dashboradmanagerCrmData',             leads: '/AllLeadsManagercrmdata',         returnTo: '/LeadsForManagers' },
};

// ─── All Data Center paths (for detection) ────────────────────────────────────
const ALL_DATA_CENTER_PATHS = [
  '/AllLeadsForAdminCRMDataQuickNumbers', '/AllLeadsForAdminCRMDatapage',
  '/TeamLeaderQuickNumbersCRMData',       '/TeamLeaderCRMDATAALLLeads',
  '/SalesQuickNumberCRMData',             '/SalesAllLeadsCRMDATA',
  '/QuickNumbersForMarketerCRMDATA',      '/ALLLeadsForMarketerCRMDATA',
  '/dashboradmanagerCrmData',             '/AllLeadsManagercrmdata',
];

// ─── menus ────────────────────────────────────────────────────────────────────
const adminMenuItems = [
  { text: 'Dashboard', icon: <GridViewRoundedIcon />,   path: '/dashboard' },
  { text: 'Leads',     icon: <PeopleAltOutlinedIcon />, path: '/AllLeadsForAdmin' },
  { text: 'Inventory', icon: <Inventory2OutlinedIcon />, children: [
      { text: 'Projects',   path: '/Project',         icon: <AccountTreeOutlinedIcon /> },
      { text: 'City',       path: '/AllCitiesShow',   icon: <ApartmentOutlinedIcon /> },
      { text: 'Developers', path: '/Developers',      icon: <HomeWorkOutlinedIcon /> },
      { text: 'Region',     path: '/Regionsandareas', icon: <LocationSearchingOutlinedIcon /> },
      { text: 'Areas',      path: '/Areas',           icon: <AddLocationOutlinedIcon /> },
  ]},
  { text: 'Sales', icon: <PersonOutlinedIcon />, children: [
      { text: 'Add Sales',    path: '/Addsales', icon: <PersonAddAltOutlinedIcon /> },
      { text: 'Manage Sales', path: '/sales',    icon: <PersonSearchOutlinedIcon /> },
  ]},
  { text: 'Marketing', icon: <CampaignOutlinedIcon />, children: [
    { text: 'Campaigns',   icon: <CampaignOutlinedIcon />,      path: '/Campaigns' },
    { text: 'Campaign Report', icon: <BarChartOutlinedIcon />, path: '/MarketingReports' },
     { text: 'CAMPAIGN & SALES Report',   icon: <CampaignOutlinedIcon />,      path: '/LeadsWithsalesincampaign' },
      
      { text: 'Channel',     icon: <VideoSettingsOutlinedIcon />,  path: '/Channel' },
      { text: 'Integration', icon: <WebhookIcon />, children: [
          { text: 'Webhook',          path: '/integration',         icon: <WebhookIcon /> },
          { text: 'Facebook',         path: '/Facebookintegration', icon: <FacebookIcon /> },
          { text: 'PF Configration', path: '/pf-configuration',     icon: <WebhookIcon /> },
          { text: 'PF Integration', path: '/property-finder-integration',     icon: <WebhookIcon /> },
          { text: 'More Integration', path: '/MoreIntegration',     icon: <ExpandCircleDownOutlinedIcon /> },

      ]},
  ]},
  { text: 'Users', icon: <GroupsOutlinedIcon />, children: [
      { text: 'Users',        path: '/Users',          icon: <PeopleAltOutlinedIcon /> },
      { text: 'Rotation',     path: '/MoreRotation',   icon: <ScreenRotationOutlinedIcon /> },
      { text: 'User Devices', path: '/AllUserDevices', icon: <ScreenRotationOutlinedIcon /> },
  ]},
  { text: 'Settings', icon: <SettingsOutlinedIcon />, children: [
      { text: 'Reports', icon: <AssessmentIcon />, children: [
          { text: 'Sales Report',     path: '/SalesReportCountLeadsInMonths', icon: <TrendingUpIcon /> },
          { text: 'Done Deal Report', path: '/DoneDealReport',                icon: <ChecklistIcon /> },
      ]},
      { text: 'Company Profile',   path: '/CompanyProfile',   icon: <SettingsOutlinedIcon /> },
      { text: 'Company Domains',   path: '/CompanyDomains',   icon: <Language /> },
      { text: 'Stages',            path: '/Stages',           icon: <HorizontalSplitOutlinedIcon /> },
      { text: 'Communication Way', path: '/Communicationway', icon: <BubbleChartOutlinedIcon /> },
      { text: 'Cancel Reason',     path: '/cancelreasons',    icon: <DoNotDisturbAltOutlinedIcon /> },
      { text: 'Trash', icon: <DeleteOutlineIcon />, children: [
          { text: 'Leads Trash',          path: '/AllLeadsnotactivated', icon: <DeleteOutlineIcon /> },
          { text: 'Stages Type Trash',    path: '/AllStagesTypeTrash',   icon: <DeleteOutlineIcon /> },
          { text: 'Stages Trash',         path: '/AllStagesTrash',       icon: <DeleteOutlineIcon /> },
          { text: 'Sales Trash',          path: '/AllSalesTrash',        icon: <DeleteOutlineIcon /> },
          { text: 'Users Trash',          path: '/AllUsersTrash',        icon: <DeleteOutlineIcon /> },
          { text: 'Comm Way Trash',       path: '/AllCommWayTrash',      icon: <DeleteOutlineIcon /> },
          { text: 'Campaign Trash',       path: '/AllCampaignTrash',     icon: <DeleteOutlineIcon /> },
          { text: 'Developers Trash',     path: '/AllDevelopersTrash',   icon: <DeleteOutlineIcon /> },
          { text: 'Projects Trash',       path: '/AllProjectsTrash',     icon: <DeleteOutlineIcon /> },
          { text: 'Cancel Reasons Trash', path: '/CancelResanosTrash',   icon: <DeleteOutlineIcon /> },
          { text: 'Channels Trash',       path: '/ChanalsTrash',         icon: <DeleteOutlineIcon /> },
          { text: 'Regions Trash',        path: '/RegionsTrash',         icon: <DeleteOutlineIcon /> },
          { text: 'Area Trash',           path: '/AreaTrash',            icon: <DeleteOutlineIcon /> },
          { text: 'Cities Trash',         path: '/CitiesTrash',          icon: <DeleteOutlineIcon /> },
      ]},
  ]},
];

const salesMenuItems = [
  { text: 'My Dashboard', path: '/SalesDashboard',   icon: <GridViewRoundedIcon /> },
  { text: 'My Leads',     path: '/AllLeadsForSales', icon: <PeopleAltOutlinedIcon /> },
  { text: 'Add Lead',     path: '/addclient',        icon: <PersonAddAltOutlinedIcon /> },
  { text: 'PF Integration', path: '/property-finder-integration',     icon: <WebhookIcon /> },

];
const teamLeaderMenuItems = [
  { text: 'My Dashboard', path: '/TeamleaderDashboard',   icon: <GridViewRoundedIcon /> },
  { text: 'My Leads',     path: '/AllLeadsForTeamLeader', icon: <PeopleAltOutlinedIcon /> },
  { text: 'My Sales',     path: '/TeamLeaderMysales',     icon: <PersonPinOutlinedIcon /> },
  { text: 'Add Lead',     path: '/addclient',             icon: <PersonAddAltOutlinedIcon /> },
  { text: 'PF Integration', path: '/property-finder-integration',     icon: <WebhookIcon /> },

];
const managerMenuItems = [
  { text: 'My Dashboard',      path: '/ManagerDashboard',         icon: <GridViewRoundedIcon /> },
  { text: 'My Leads',          path: '/LeadsForManagers',         icon: <PeopleAltOutlinedIcon /> },
  { text: 'My Team Leaders',   path: '/MyTeamLeadersForManagers', icon: <SwitchAccountOutlinedIcon /> },
  { text: 'My Team Analytics', path: '/TeamAnalyticForManager',   icon: <StackedLineChartOutlinedIcon /> },
  { text: 'Add Lead',          path: '/addclient',                icon: <PersonAddAltOutlinedIcon /> },
  { text: 'PF Integration', path: '/property-finder-integration',     icon: <WebhookIcon /> },

];
const accountantMenuItems = [
  { text: 'My Done Deals',      path: '/LeadsForAccountant',                  icon: <Diversity3Icon /> },
  { text: 'Sales Report',       path: '/SalesMonyinMonthReportForAccountant', icon: <ShowChartIcon /> },
  { text: 'Developers Account', path: '/DeveloperAccounts',                   icon: <AccountBoxIcon /> },
  { text: 'Add Tasks',          path: '/AccountantTasks',                     icon: <AddTaskIcon /> },
  { text: 'Manage Tasks',       path: '/ManageAccountantTasks',               icon: <AssignmentIcon /> },
  { text: 'Inventory', icon: <Inventory2OutlinedIcon />, children: [
      { text: 'Projects',   path: '/Project',    icon: <AssistantPhotoIcon /> },
      { text: 'City',       path: '/AddCity',    icon: <WhereToVoteIcon /> },
      { text: 'Developers', path: '/Developers', icon: <LoupeIcon /> },
  ]},
];
const marketerMenuItems = [
  { text: 'Dashboard', path: '/dashboard', icon: <GridViewRoundedIcon /> },
  { text: 'Leads', path: '/ALLLeadsForMarketer', icon: <PersonSearchOutlinedIcon /> },
  { text: 'Inventory', icon: <Inventory2OutlinedIcon />, children: [
      { text: 'Projects',   path: '/Project',    icon: <AccountTreeOutlinedIcon /> },
      { text: 'City',       path: '/AddCity',    icon: <ApartmentOutlinedIcon /> },
      { text: 'Developers', path: '/Developers', icon: <HomeWorkOutlinedIcon /> },
  ]},
  { text: 'Stages',            icon: <HorizontalSplitOutlinedIcon />, path: '/Stages' },
  { text: 'Channel',           icon: <VideoSettingsOutlinedIcon />,   path: '/Channel' },
  { text: 'Regions & Areas', icon: <SouthAmericaIcon />, children: [
      { text: 'Region', path: '/Regionsandareas', icon: <LocationSearchingOutlinedIcon /> },
      { text: 'Areas',  path: '/Areas',           icon: <AddLocationOutlinedIcon /> },
  ]},
  { text: 'Communication Way', icon: <BubbleChartOutlinedIcon />,     path: '/Communicationway' },
  { text: 'Campaigns',         icon: <CampaignOutlinedIcon />,        path: '/Campaigns' },
  { text: 'Cancel Reason',     icon: <DoNotDisturbAltOutlinedIcon />, path: '/cancelreasons' },
  { text: 'Reports', icon: <BarChartOutlinedIcon />, children: [
      { text: 'Marketing Reports', path: '/MarketingReports',          icon: <BarChartOutlinedIcon /> },
      { text: 'Campaigns Reports', path: '/CampaignsReports',          icon: <BarChartOutlinedIcon /> },
      { text: 'Collect Reports',   path: '/ImportantMarketingReports', icon: <BarChartOutlinedIcon /> },
  ]},
  { text: 'Integration', icon: <WebhookIcon />, children: [
      { text: 'Webhook',          path: '/integration',         icon: <WebhookIcon /> },
      { text: 'Facebook',         path: '/Facebookintegration', icon: <FacebookIcon /> },
      { text: 'More Integration', path: '/MoreIntegration',     icon: <ExpandCircleDownOutlinedIcon /> },
     { text: 'PF Integration', path: '/property-finder-integration',     icon: <WebhookIcon /> },

  ]},
];

const menuMap = {
  Admin: adminMenuItems, Sales: salesMenuItems,
  'Team Leader': teamLeaderMenuItems, Manager: managerMenuItems,
  Accountant: accountantMenuItems,   Marketer: marketerMenuItems,
};

// ─── helpers ──────────────────────────────────────────────────────────────────
const hasActiveChild = (node, pathname) => {
  if (node.path) return pathname === node.path;
  return node.children?.some(c => hasActiveChild(c, pathname));
};

// ─── NavLeaf ──────────────────────────────────────────────────────────────────
const NavLeaf = ({ item, depth, expanded, onExpand }) => {
  const { pathname } = useLocation();
  const active = pathname === item.path;

  const inner = (
    <ListItem button component={Link} to={item.path}
      onClick={() => { if (!expanded) onExpand(); }}
      sx={{
        pl: expanded ? `${16 + depth * 14}px` : 0,
        pr: expanded ? '12px' : 0,
        py: '10px',
        mx: expanded ? '8px' : '6px',
        width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
        borderRadius: '8px', mb: '2px',
        position: 'relative',
        justifyContent: expanded ? 'flex-start' : 'center',
        bgcolor: active ? '#FFFFFF' : 'transparent',
        boxShadow: active ? '0 1px 6px rgba(0,0,0,0.08)' : 'none',
        transition: 'all 0.2s',
        '&:hover': { bgcolor: active ? '#FFFFFF' : C.hoverBg },
        '&::before': active && expanded ? {
          content: '""', position: 'absolute',
          left: 0, top: '18%', bottom: '18%',
          width: '3px', bgcolor: C.accent,
          borderRadius: '0 3px 3px 0',
        } : {},
      }}
    >
      <ListItemIcon sx={{
        minWidth: 0, mr: expanded ? '10px' : 0,
        color: active ? C.accent : C.textMuted,
        '& svg': { fontSize: '20px' },
        transition: 'color 0.15s',
        justifyContent: 'center',
      }}>
        {item.icon}
      </ListItemIcon>
      {expanded && (
        <ListItemText primary={item.text} primaryTypographyProps={{
          fontSize: depth === 0 ? '13.5px' : '13px',
          fontWeight: active ? 600 : 400,
          color: active ? C.accent : (depth > 0 ? C.textMuted : C.text),
          fontFamily: "'DM Sans', sans-serif",
        }} />
      )}
    </ListItem>
  );

  return expanded ? inner : <Tooltip title={item.text} placement="right" arrow>{inner}</Tooltip>;
};

// ─── NavGroup ─────────────────────────────────────────────────────────────────
const NavGroup = ({ item, depth, expanded, onExpand }) => {
  const { pathname } = useLocation();
  const childActive = hasActiveChild(item, pathname);
  const [open, setOpen] = useState(false);

  useEffect(() => { if (childActive && expanded) setOpen(true); }, [pathname, expanded]);
  useEffect(() => { if (!expanded) setOpen(false); }, [expanded]);

  const handleClick = () => {
    if (!expanded) { onExpand(); return; }
    setOpen(p => !p);
  };

  const inner = (
    <ListItem button onClick={handleClick}
      sx={{
        pl: expanded ? `${16 + depth * 14}px` : 0,
        pr: expanded ? '12px' : 0,
        py: '10px',
        mx: expanded ? '8px' : '6px',
        width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
        borderRadius: '8px', mb: '2px',
        justifyContent: expanded ? 'flex-start' : 'center',
        bgcolor: childActive && !open && expanded ? 'rgba(26,62,207,0.06)' : 'transparent',
        transition: 'all 0.2s',
        '&:hover': { bgcolor: C.hoverBg },
      }}
    >
      <ListItemIcon sx={{
        minWidth: 0, mr: expanded ? '10px' : 0,
        color: childActive ? C.accent : C.textMuted,
        '& svg': { fontSize: '20px' },
        transition: 'color 0.15s',
        justifyContent: 'center',
      }}>
        {item.icon}
      </ListItemIcon>
      {expanded && (
        <>
          <ListItemText primary={item.text} primaryTypographyProps={{
            fontSize: depth === 0 ? '13.5px' : '13px',
            fontWeight: childActive ? 600 : 400,
            color: childActive ? C.accent : (depth > 0 ? C.textMuted : C.text),
            fontFamily: "'DM Sans', sans-serif",
          }} />
          {open
            ? <ExpandLess sx={{ fontSize: '16px', color: C.textMuted }} />
            : <ExpandMore sx={{ fontSize: '16px', color: C.textMuted }} />}
        </>
      )}
    </ListItem>
  );

  return (
    <>
      {expanded ? inner : <Tooltip title={item.text} placement="right" arrow>{inner}</Tooltip>}
      {expanded && (
        <Collapse in={open} timeout={180} unmountOnExit>
          {depth === 0 ? (
            <Box sx={{ ml: '34px', borderLeft: `1.5px solid ${C.border}`, my: '2px', pl: '2px' }}>
              <List disablePadding>
                {item.children.map((child, i) =>
                  child.children
                    ? <NavGroup key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
                    : <NavLeaf  key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
                )}
              </List>
            </Box>
          ) : (
            <List disablePadding sx={{ pl: '6px' }}>
              {item.children.map((child, i) =>
                child.children
                  ? <NavGroup key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
                  : <NavLeaf  key={i} item={child} depth={depth + 1} expanded={expanded} onExpand={onExpand} />
              )}
            </List>
          )}
        </Collapse>
      )}
    </>
  );
};

// ─── FooterRow ────────────────────────────────────────────────────────────────
const FooterRow = ({ icon, label, onClick, danger, expanded }) => {
  const inner = (
    <ListItem button onClick={onClick}
      sx={{
        px: expanded ? '12px' : 0, py: '9px',
        mx: expanded ? '8px' : '6px',
        width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
        borderRadius: '8px', mb: '1px',
        justifyContent: expanded ? 'flex-start' : 'center',
        gap: expanded ? '10px' : 0,
        transition: 'all 0.2s',
        '&:hover': { bgcolor: danger ? 'rgba(239,68,68,0.06)' : C.hoverBg },
        '&:hover .fi': { color: danger ? '#EF4444' : C.text },
        '&:hover .fl': { color: danger ? '#EF4444' : C.text },
      }}
    >
      <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center', '& svg': { fontSize: '19px' } }}>
        <Box component="span" className="fi"
          sx={{ color: C.textMuted, display: 'flex', transition: 'color 0.15s' }}>
          {icon}
        </Box>
      </ListItemIcon>
      {expanded && (
        <ListItemText className="fl" primary={label} primaryTypographyProps={{
          fontSize: '13.5px', fontWeight: 400, color: C.text,
          fontFamily: "'DM Sans', sans-serif",
          sx: { transition: 'color 0.15s' },
        }} />
      )}
    </ListItem>
  );
  return expanded ? inner : <Tooltip title={label} placement="right" arrow>{inner}</Tooltip>;
};

// ─── DataCenterNav — الـ menu المخصص لصفحات الـ Data Center ──────────────────
const DataCenterNav = ({ routes, expanded, onExpand, navigate }) => {
  const { pathname } = useLocation();

  const items = [
    {
      text: 'DC Dashboard',
      path: routes.dashboard,
      icon: <StorageOutlinedIcon />,
    },
    {
      text: 'DC Leads',
      path: routes.leads,
      icon: <PeopleAltOutlinedIcon />,
    },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

      {/* ── Badge: Data Center mode ── */}
      {expanded && (
        <Box sx={{
          mx: '12px', mb: '8px', mt: '4px',
          px: '10px', py: '7px',
          borderRadius: '8px',
          bgcolor: 'rgba(217,119,6,0.08)',
          border: '1px solid rgba(217,119,6,0.2)',
          display: 'flex', alignItems: 'center', gap: '8px',
        }}>
          <StorageOutlinedIcon sx={{ fontSize: '14px', color: '#D97706', flexShrink: 0 }} />
          <Typography sx={{
            fontSize: '11px', fontWeight: 700, color: '#D97706',
            fontFamily: "'DM Sans', sans-serif",
            letterSpacing: '0.06em', textTransform: 'uppercase',
          }}>
            Data Center Mode
          </Typography>
        </Box>
      )}

      {/* ── Nav items ── */}
      <List disablePadding sx={{ flex: 1 }}>
        {items.map((item, i) => {
          const active = pathname === item.path;
          const inner = (
            <ListItem
              key={i}
              button
              component={Link}
              to={item.path}
              onClick={() => { if (!expanded) onExpand(); }}
              sx={{
                pl: expanded ? '16px' : 0,
                pr: expanded ? '12px' : 0,
                py: '10px',
                mx: expanded ? '8px' : '6px',
                width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
                borderRadius: '8px', mb: '2px',
                position: 'relative',
                justifyContent: expanded ? 'flex-start' : 'center',
                bgcolor: active ? '#FFFFFF' : 'transparent',
                boxShadow: active ? '0 1px 6px rgba(0,0,0,0.08)' : 'none',
                transition: 'all 0.2s',
                '&:hover': { bgcolor: active ? '#FFFFFF' : C.hoverBg },
                '&::before': active && expanded ? {
                  content: '""', position: 'absolute',
                  left: 0, top: '18%', bottom: '18%',
                  width: '3px', bgcolor: '#D97706',
                  borderRadius: '0 3px 3px 0',
                } : {},
              }}
            >
              <ListItemIcon sx={{
                minWidth: 0, mr: expanded ? '10px' : 0,
                color: active ? '#D97706 !important' : C.textMuted,
                '& svg': { fontSize: '20px' },
                transition: 'color 0.15s',
                justifyContent: 'center',
              }}>
                {item.icon}
              </ListItemIcon>
              {expanded && (
                <ListItemText primary={item.text} primaryTypographyProps={{
                  fontSize: '13.5px',
                  fontWeight: active ? 600 : 400,
                  color: active ? '#D97706' : C.text,
                  fontFamily: "'DM Sans', sans-serif",
                }} />
              )}
            </ListItem>
          );
          return expanded
            ? inner
            : <Tooltip key={i} title={item.text} placement="right" arrow>{inner}</Tooltip>;
        })}
      </List>

      {/* ── Divider ── */}
      <Box sx={{ mx: expanded ? '16px' : '10px', my: '8px', height: '1px', bgcolor: C.divider }} />

      {/* ── Return to Original Leads ── */}
      {(() => {
        const inner = (
          <ListItem
            button
            component={Link}
            to={routes.returnTo}
            sx={{
              pl: expanded ? '16px' : 0,
              pr: expanded ? '12px' : 0,
              py: '10px',
              mx: expanded ? '8px' : '6px',
              width: expanded ? 'calc(100% - 16px)' : 'calc(100% - 12px)',
              borderRadius: '8px', mb: '2px',
              justifyContent: expanded ? 'flex-start' : 'center',
              bgcolor: 'rgba(26,62,207,0.05)',
              border: '1px solid rgba(26,62,207,0.12)',
              transition: 'all 0.2s',
              '&:hover': {
                bgcolor: 'rgba(26,62,207,0.1)',
                borderColor: 'rgba(26,62,207,0.3)',
              },
            }}
          >
            <ListItemIcon sx={{
              minWidth: 0, mr: expanded ? '10px' : 0,
              color: '#1A3ECF !important',
              '& svg': { fontSize: '20px' },
              justifyContent: 'center',
            }}>
              <ArrowBackOutlinedIcon />
            </ListItemIcon>
            {expanded && (
              <ListItemText primary="Original Leads" primaryTypographyProps={{
                fontSize: '13.5px', fontWeight: 600,
                color: '#1A3ECF !important',
                fontFamily: "'DM Sans', sans-serif",
              }} />
            )}
          </ListItem>
        );
        return expanded
          ? inner
          : <Tooltip title="Return to Original Leads" placement="right" arrow>{inner}</Tooltip>;
      })()}
    </Box>
  );
};

// ─── Main ─────────────────────────────────────────────────────────────────────
export const Leftsidebare2 = ({ setmode, mode, openDrawer, isMobile, toggleDrawer, setOpenDrawer, onExpandedChange }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [expanded,      setExpanded]      = useState(true);
  const [userlogin,     setUserlogin]     = useState(null);
  const [loadinglogout, setLoadinglogout] = useState(true);
  const [isLoggedOut,   setIsLoggedOut]   = useState(localStorage.getItem('isLoggedIn'));
  const savedDeviceId = localStorage.getItem('deviceId');

  const handleExpand = () => {
    setExpanded(true);
    localStorage.setItem('sidebarExpanded', 'true');
  };

  useEffect(() => {
    if (typeof onExpandedChange === 'function') onExpandedChange(expanded);
    window.dispatchEvent(new CustomEvent('sidebarResized', {
      detail: { width: expanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH }
    }));
  }, [expanded]);

  useEffect(() => {
    const u = JSON.parse(localStorage.getItem('user'));
    if (u) setUserlogin(u);
  }, []);

  useEffect(() => {
    const path = location.pathname;
    const hide = path === '/' || path === '/Login';
    if (typeof setOpenDrawer === 'function') setOpenDrawer(!hide);
    const nb = document.getElementById('navbarr');
    if (nb) nb.style.display = hide ? 'none' : 'flex';
  }, [location.pathname, setOpenDrawer]);

  const logout = async () => {
    setLoadinglogout(true);
    await dispatch(Logoutsession_one_Device(userlogin?.data?._id, savedDeviceId));
    setLoadinglogout(false);
  };

  useEffect(() => {
    if (!loadinglogout) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.setItem('isLoggedIn', 'false');
      window.location.href = '#/';
    }
  }, [loadinglogout]);

  const role         = userlogin?.data?.role;
  const menuItems    = menuMap[role] || [];
  const isPrivileged = ['Sales','Team Leader','Manager','Admin','Marketer','Accountant'].includes(role);
  const drawerWidth  = expanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH;

  // ── هل أنا في Data Center دلوقتي؟ ────────────────────────────────────────
  const isInDataCenter = ALL_DATA_CENTER_PATHS.includes(location.pathname);
  const dataCenterRoutes = DATA_CENTER_ROUTES[role];

  if (isLoggedOut !== 'true') return null;

  const content = (
    <Box sx={{
      display: 'flex', flexDirection: 'column',
      height: '100%', bgcolor: C.sidebarBg,
      width: drawerWidth,
      transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflow: 'hidden',
    }}>

      {/* ── Brand + toggle ── */}
      <Box sx={{
        height: '64px',
        px: expanded ? 2.5 : 0,
        display: 'flex', alignItems: 'center',
        justifyContent: expanded ? 'space-between' : 'center',
        bgcolor: C.topBg,
        borderBottom: `1px solid ${C.border}`,
        flexShrink: 0,
      }}>
        {expanded && (
          <Box>
            <Typography sx={{
              fontFamily: "'DM Sans', sans-serif", fontWeight: 800, fontSize: '12.5px',
              color: C.accent, letterSpacing: '0.13em', textTransform: 'uppercase',
              lineHeight: 1.3, whiteSpace: 'nowrap',
            }}>
              Realatix CRM
            </Typography>
            <Typography sx={{
              fontFamily: "'DM Sans', sans-serif", fontWeight: 400, fontSize: '9px',
              color: C.textMuted, letterSpacing: '0.15em',
              textTransform: 'uppercase', whiteSpace: 'nowrap',
            }}>
              {isInDataCenter ? 'Data Center' : 'Elite Tier Access'}
            </Typography>
          </Box>
        )}

        <Tooltip title={expanded ? 'Collapse' : 'Expand'} placement="right">
          <Box
            onClick={() => setExpanded(p => {
              const next = !p;
              localStorage.setItem('sidebarExpanded', String(next));
              return next;
            })}
            sx={{
              width: 28, height: 28, borderRadius: '6px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', flexShrink: 0,
              color: C.textMuted,
              border: `1px solid ${C.border}`,
              bgcolor: '#fff',
              transition: 'all 0.15s',
              '&:hover': { color: C.accent, borderColor: C.accent, bgcolor: 'rgba(26,62,207,0.04)' },
            }}
          >
            {expanded
              ? <ChevronLeftIcon  sx={{ fontSize: '17px' }} />
              : <ChevronRightIcon sx={{ fontSize: '17px' }} />}
          </Box>
        </Tooltip>
      </Box>

      {/* ── Nav ── */}
      <Box sx={{
        flex: 1, overflowY: 'auto', overflowX: 'hidden', py: '10px',
        scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' },
      }}>
        {/* لو في Data Center → اعرض الـ menu المخصص، غير كده → الـ menu العادي */}
        {isInDataCenter && dataCenterRoutes ? (
          <DataCenterNav
            routes={dataCenterRoutes}
            expanded={expanded}
            onExpand={handleExpand}
            navigate={navigate}
          />
        ) : (
          <List disablePadding>
            {menuItems.map((item, i) =>
              item.children
                ? <NavGroup key={i} item={item} depth={0} expanded={expanded} onExpand={handleExpand} />
                : <NavLeaf  key={i} item={item} depth={0} expanded={expanded} onExpand={handleExpand} />
            )}
          </List>
        )}
      </Box>

      {/* ── CTA — بس لو مش في Data Center ── */}
      {!isInDataCenter && (
        <Box sx={{ px: expanded ? 1.5 : '6px', pb: 1, flexShrink: 0 }}>
          {expanded ? (
            <Box onClick={() => navigate('/addclient')} sx={{
              bgcolor: '#0D47A1', color: '#fff', borderRadius: '8px', py: '11px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              gap: '7px', cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif", fontSize: '12px', fontWeight: 700,
              letterSpacing: '0.1em', textTransform: 'uppercase',
              boxShadow: '0 2px 10px rgba(26,62,207,0.22)',
              transition: 'background 0.15s, box-shadow 0.15s',
              '&:hover': { bgcolor: C.ctaHover },
              '&:active': { transform: 'scale(0.98)' },
            }}>
              <AddCircleOutlinedIcon sx={{ fontSize: '16px' }} />
              Create New Lead
            </Box>
          ) : (
            <Tooltip title="New Listing" placement="right">
              <Box onClick={() => navigate('/addclient')} sx={{
                bgcolor: C.ctaBg, color: '#0D47A1', borderRadius: '8px', py: '10px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', boxShadow: '0 2px 10px rgba(26,62,207,0.22)',
                '&:hover': { bgcolor: C.ctaHover },
              }}>
                <AddCircleOutlinedIcon sx={{ fontSize: '20px' }} />
              </Box>
            </Tooltip>
          )}
        </Box>
      )}

      {/* ── Footer ── */}
      {isPrivileged && (
        <Box sx={{ borderTop: `1px solid ${C.divider}`, pt: '6px', pb: '10px', flexShrink: 0 }}>
          <FooterRow icon={<HelpOutlineIcon />}           label="Support"  onClick={() => navigate('/support')}   expanded={expanded} />
          <FooterRow icon={<AccountCircleOutlinedIcon />} label="Account"  onClick={() => navigate('/MyAccount')} expanded={expanded} />
          {/* <FooterRow icon={<LogoutIcon />}                label="Logout"   onClick={logout} danger expanded={expanded} /> */}
        </Box>
      )}
    </Box>
  );

  return (
    <Drawer
      variant={isMobile ? 'temporary' : 'persistent'}
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)',
        zIndex: (t) => t.zIndex.appBar,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          top: 0, height: '100vh',
          border: 'none',
          borderRight: `1px solid ${C.border}`,
          overflowX: 'hidden',
          bgcolor: C.sidebarBg,
          transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)',
        },
      }}
    >
      {content}
    </Drawer>
  );
};
